 
<template>
  <div class="Bgc-white">
    <Header />
    <SidebarReservaTop class="barTop" position="top" :infoReserva="infoReserva" />
    <div class="container espacio justify-content-center">
      <div class="row w-100">
        <div class="col-12 col-lg-9">
          <!-- Pasos -->
          <div class="steps">
            <div class="pasos ativePaso d-inline-block">
              {{ $t('language.posadasCorporate.reservacionesRegistro.reservation') }} <i class=" icon-right"></i>
            </div>
            <div class="pasos d-inline-block">
              {{ $t('language.posadasCorporate.reservacionesRegistro.paymentMethods') }} <i class=" icon-right"></i>
            </div>
            <div class="pasos d-inline-block">
              {{ $t('language.posadasCorporate.reservacionesRegistro.confirmation') }} <i class=" icon-right"></i>
            </div>
          </div>

          <!-- Habitaciones -->
          <form @submit.prevent="">
            <div class="habitaciones">
              <!-- Habitacion 1 -->
              <div class="habitacion" v-if="showMainRoom">
                <div class="habitacionHeader">
                  <p v-b-toggle="'habitacion1'" class="habitacionTitle"
                    @click="(habitacion1.iconoHabitacion == 0) ? habitacion1.iconoHabitacion = 100 : habitacion1.iconoHabitacion = 0">
                    {{ $t('language.posadasCorporate.reservacionesRegistro.room') }} 1
                    <i class="navi icon-up" :class="(habitacion1.iconoHabitacion == 0) ? '' : 'oculto'"></i>
                    <i class="navi icon-navigate-down" :class="(habitacion1.iconoHabitacion == 0) ? 'oculto' : ''"></i>
                  </p>
                </div>
                <b-collapse class="habitacionBody" visible id="habitacion1" role="tablist">
                  <div v-if="enableRewards" class="statusBar statusBar__error">
                    <i class="icon icon-close-rounded-outline"></i>
                    <span>{{ $t('language.posadasCorporate.reservacionesRegistro.errorEw') }}</span>
                  </div>

                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion1.datosPersonales"
                      :class="(habitacion1.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(habitacion1.iconoActivo == 0) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 0"
                      v-b-toggle="'datosPersonales'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <i class="navi icon-up" :class="(habitacion1.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion1.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion1.datosPersonales"
                      @click="(habitacion1.iconoActivo == 0) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 0"
                      v-b-toggle="'datosPersonales'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <span class="editarDatos"
                        @click="[habitacion1.datosPersonales = true, formulario1.huesped = false]">
                        {{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}
                      </span>
                    </p>
                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonales" visible accordion="my-accordion" role="tabpanel">
                      <Loader v-if="banLoaderPerfiles" />
                      <div class="row">
                        <!-- Perfiles Existentes -->
                        <div v-if="!isUserGeneric" class="form-element col-12" v-click-outside="outsideSearch">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.existingProfiles') }}</label>
                          <div class="contenidoSearch">
                            <i class="search-icons icon-search" v-if="!habitacion1.buscador"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion1.buscador"
                              @click="habitacion1.search = '', cleanGuestProfileDetail(), filteredList()"></i>
                            <input class="elipse" type="text" @keydown="cleanGuestProfileDetail()"
                              @click="habitacion1.buscador = true, filteredList()" v-on:input="filteredList()"
                              :disabled="banLoaderPerfiles"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                              v-model="habitacion1.search" v-onlyText @paste="handlePaste" onkeypress="return (event.charCode != 124)" >
                          </div>
                          <div class="card buscadorCard vb" v-if="habitacion1.buscador" v-bar>
                            <div>
                              <div class="buscador pointer" v-for="perfil in habitacion1.perfilesLista"
                                :key="perfil.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaValue(perfil.nombre, perfil.guestProfileId, perfil), habitacion1.buscador = 0]; habitacion1.search = perfil.nombre"
                                  v-html="$options.filters.resalt(perfil.nombre, habitacion1.search)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.name') }}*</label>
                          <input type="text" maxlength="26"
                            :class="habitacion1.nombres == '' || enableRewards ? 'error-code' : ''" id="simpleName" v-model="simpleName"
                            class="inputUppercase" @paste="handlePaste" onkeypress="return (event.charCode != 124)"   >
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.lastName') }}*</label>
                          <input type="text" maxlength="26" pattern="[A-Za-z0-9]{1,15}"
                            :class="habitacion1.apellidoP == '' || enableRewards ? 'error-code' : ''"
                            v-model="fatherSurname" class="inputUppercase" @paste="handlePaste"   onkeypress="return (event.charCode != 124)"  >
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.secondLastName') }}</label>
                          <input type="text" maxlength="26"  
                          :class="habitacion1.apellidoM == '' || enableRewards ? 'error-code' : ''"
                           v-model="motherSurname"  class="inputUppercase" @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                        </div>                      


                        <!-- informacion empresa -->
                        <div class="form-element col-12 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.employeeNumber') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax20')"
                            v-model="agentNumber" maxlength="20" class="inputUppercase"  @paste="handlePaste"  onkeypress="return (event.charCode != 124)" >
                        </div>
                        <div class="form-element col-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.fiestaNumber') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax12')"
                            :class="(rewardsNumber.length > 0 && rewardsNumber.length < 7 || enableRewards ? true : false) ? 'error-code' : ''"
                            @blur="consultFiestaRewards()" v-model="rewardsNumber" maxlength="12"
                            class="inputUppercase"  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <!-- Fiesta Rewards Card-->
                        <div v-if="banLoaderFR || banMemFR" class="fr-card-container">
                          <Loader v-if="banLoaderFR" />
                          <div v-if="banMemFR" class="fr-card">
                            <div class="fr-card-section fr-card-section__type">
                              <b>{{ infoFR.fiestaRewardsPartnerType }}</b>

                              <img v-if="srcImageFRCard === 1"
                                src="../../../assets/img/fiesta_rewards_cards/clasica_es.png">
                              <img v-if="srcImageFRCard === 2"
                                src="../../../assets/img/fiesta_rewards_cards/clasica_en.png">

                              <img v-if="srcImageFRCard === 3"
                                src="../../../assets/img/fiesta_rewards_cards/oro_es.png">
                              <img v-if="srcImageFRCard === 4"
                                src="../../../assets/img/fiesta_rewards_cards/oro_en.png">

                              <img v-if="srcImageFRCard === 5"
                                src="../../../assets/img/fiesta_rewards_cards/platino_es.png">
                              <img v-if="srcImageFRCard === 6"
                                src="../../../assets/img/fiesta_rewards_cards/platino_en.png">

                              <img v-if="srcImageFRCard === 7"
                                src="../../../assets/img/fiesta_rewards_cards/black_es.png">
                              <img v-if="srcImageFRCard === 8"
                                src="../../../assets/img/fiesta_rewards_cards/black_en.png">

                              <img v-if="srcImageFRCard === 9"
                                src="../../../assets/img/fiesta_rewards_cards/omnia_es.png">
                              <img v-if="srcImageFRCard === 10"
                                src="../../../assets/img/fiesta_rewards_cards/omnia_en.png">

                            </div>
                            <div class="fr-card-section fr-card-section__points">
                              <span
                                class="PC-text--size12">{{ $t('language.posadasCorporate.reservacionesRegistro.saldoActual') }}:</span>
                              <span class="bold link PC-text--size20">{{ infoFR.fiestaRewardsBalance }}</span>
                              <span
                                class="link PC-text--size12">{{ $t('language.posadasCorporate.reservacionesRegistro.puntosFiestaRewards') }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="form-element col-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.apreciareClub') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax18')"
                            v-model="apreciation" maxlength="18" class="inputUppercase" :disabled="getApreciareOff"
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-12 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.costsCentre') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax20')"
                           v-model="costCenter" maxlength="20"  @paste="handlePaste"  onkeypress="return (event.charCode != 124)" v-onlyText > 
                            
                        </div>
                        <div class="col-12">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                       
                   <!-- Boton -->
                   <!-- START KB49419 -->
                        <div v-if="this.banMemFR != true" class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonales'" >
                          <button class="button" 
                            @click="[habitacion1.datosPersonales = false, habitacion1.datosContacto = true, formulario1.huesped = true, setDataPersonalH1(), validationMemberFR()]"
                            :disabled="isDisabledHuesped">{{ $t('language.posadasCorporate.reservacionesRegistro.continueOne') }} </button>
                        </div>


                        <div v-if="this.banMemFR == true" class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonales'" v-b-toggle.datosContacto>
                          <button class="button" 
                            @click="[habitacion1.datosPersonales = false, habitacion1.datosContacto = true, formulario1.huesped = true, setDataPersonalH1()]"
                            :disabled="isDisabledHuesped">{{ $t('language.posadasCorporate.reservacionesRegistro.continueOne') }} </button>
                        </div>

                   <!-- END KB49419-->


                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion1.datosContacto"
                      :class="(habitacion1.iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(habitacion1.iconoActivo == 1) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 1"
                      v-b-toggle="'datosContacto'" accordion="my-accordion" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <i class="navi icon-up" :class="(habitacion1.iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion1.iconoActivo == 1) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion1.datosContacto"
                      @click="(habitacion1.iconoActivo == 1) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 1"
                      v-b-toggle="'datosContacto'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <span class="editarDatos"
                        @click="[habitacion1.datosContacto = true, formulario1.contacto = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContacto" accordion="my-accordion" role="tabpanel">
                      <div class="row">

                        <!-- Tipo de teléfono -->
                        <!-- INI KB48464 -->
                        <!--
                        <div class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.phoneType') }}*</label><br>
                          <label class="col-4 pl-0 radio">
                            <input type="radio" class="hidden" value="MOB" v-model="pickedTelelefonoCelular" @click="resetFlagModalTelephone()">
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.reservacionesRegistro.mobile') }}</span>
                          </label>
                          <label class="col-4 pl-0 radio">
                            <input type="radio" class="hidden" value="HOM" v-model="pickedTelelefonoCelular"  @click="falseFlagModalTelephone()">
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.reservacionesRegistro.casa') }}</span>
                          </label>
                          <label class="col-4 pl-0 radio">
                            <input type="radio" class="hidden" value="BUS" v-model="pickedTelelefonoCelular" @click="falseFlagModalTelephone()">
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.reservacionesRegistro.office') }}</span>
                          </label>
                        </div>
                        -->
                        <!-- Núm. telefónico -->
                        <!--
                        <div class="form-element col-12 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.phoneNumber') }}*</label>
                          -->
                          <!--
                          <input type="text" maxlength="10" v-model="habitacion1.numTelefonico" v-onlyNumbers :placeholder="$t('language.posadasCorporate.reservacionesRegistro.digitos10')">  v-onlyText  

                          KB47296 Start
                            <vue-tel-input :value="habitacion1.numTelefonico"  @focus="showModalTelephone()"  onkeypress="return (event.charCode != 124) "  
                                          @paste="handlePaste"  @validate="handleValidatePhoneNumber" @input="handleOnInputPhoneNumber" @blur="handleOnBlurPhoneNumber" @country-changed="handleCountryChanged" :key="telInput"></vue-tel-input>
                         
                             KB47296 End 
                            FIN KB48464 
                        </div>
                            -->

                        <!-- Telefono Codigo de país KB56697-->
                          <div class="form-element col-lg-6" v-click-outside="outsideTelefono">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.codePais') }}*</label>
                          <div class="contenidoSearch" @click="[boleanTelefono = true]">
                            <i class="search-icons icon-search" v-if="!boleanTelefono"></i>
                            <i class="search-icons icon-close pointer" v-if="boleanTelefono"
                              @click="codePaisNew = ''; resetSelectedTelefono()"></i>
                            <input class="elipse pointer" type="text" id="telefonoSeleccionado"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                               @click="filteredListTelefono()"
                              v-model="codePaisNew" onkeypress="return (event.charCode != 124)" @paste="handlePaste" @input="handleOnInputPhoneNumber">
                          </div>

                          <div class="card buscadorCard vb" v-if="boleanTelefono" v-bar>
                            <div>
                              <div class="buscador" v-for="jsonPaises in filteredListTelefono" :key="jsonPaises.id">
                                <p class="mb-1 nombre" @click="[cambiaTelefono(jsonPaises), boleanTelefono = false]"
                                  v-html="$options.filters.resalt(jsonPaises.name  + ' +' +  jsonPaises.lada, codePaisNew)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- numero telefonico-->
                        <!-- START KB56697-->
                        <div class="form-element col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.numerotelefono') }} * </label>
                          <input type="text" name="" v-model="numeroTelNew" maxlength="15" :placeholder="$t('language.posadasCorporate.generals.caracteresMax15')"
                            @paste="handlePaste"  onkeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"  @focus="showModalTelephone()">
                        </div>
                        <!-- END KB56697-->


                        <!-- Correo electrónico* -->
                        <div class="form-element col-12 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.email') }}*</label>
                          <input maxlength="50" type="text"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="habitacion1.mailContacto" v-email onkeypress="return (event.charCode != 124) " 
                            :class="{ 'is-invalid': (!$v.habitacion1.mailContacto.email) }">
                          <span class="notas"
                            v-if="!$v.habitacion1.mailContacto.email">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>
                        </div>
                        <div class="form-element col-12 col-lg-6">
                          <label
                            for="">{{ $t('language.posadasCorporate.reservacionesRegistro.ultimateTranslation') }}</label>
                            <input maxlength="50" type="text"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="habitacion1.mailContactoConfirmacion" v-email  onkeypress="return (event.charCode != 124) " 
                            :class="{ 'is-invalid': (!$v.habitacion1.mailContactoConfirmacion.email) }"  >

                          <span class="notas"
                            v-if="!$v.habitacion1.mailContacto">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>
                          <span class="notas">{{ $t('language.posadasCorporate.reservacionesRegistro.copy1') }}</span><br>
                          <span class="notas"
                            v-if="emailIsRepeated">{{ $t('language.posadasCorporate.reservacionesRegistro.copy0') }}{{ emailProfile }}</span>

                        </div>

                        <!-- direccion -->
                        <div class="form-element col-12 col-lg-3">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.newAddress') }}</label><br>
                          <label class="col-6 pl-0 radio">
                            <input type="radio" id="casaD" class="hidden" value="MOB" v-model="pickedDireccion"
                              v-onlyText>
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.reservacionesRegistro.casa') }}</span>
                          </label>
                          <label class="col-6 pl-0 radio">
                            <input type="radio" id="oficinaD" class="hidden" value="BUS" v-model="pickedDireccion"
                              v-onlyText>
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.reservacionesRegistro.office') }}</span>
                          </label>
                        </div>

                        <!-- Calle numero -->
                        <div class="form-element col-12 col-lg-9">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.street') }}</label>
                          <input maxlength="50" type="text" name="" v-model="street" class="inputUppercase"
                                @paste="handlePaste" onkeypress="return (event.charCode != 124) "  >
                        </div>

                        <!-- Colonia -->
                        <div class="form-element col-12 col-lg-9">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.community') }}</label>
                          <input maxlength="50" type="text" name="" v-model="localityF" id="localityF" class="inputUppercase"
                               @paste="handlePaste" onkeypress="return (event.charCode != 124) "  >
                        </div>

                        <!-- Código Postal -->
                        <div class="form-element col-12 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.postOffice') }}</label>
                          <input maxlength="10" type="text" name="" v-model="zipCode" class="inputUppercase"
                            @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                        </div>

                        <!-- Pais -->
                        <div class="form-element col-6" v-click-outside="outsidePais">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.country') }}*</label>
                          <div class="contenidoSearch" @click="[habitacion1.pais = true]">
                            <i class="search-icons icon-search" v-if="!habitacion1.pais"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion1.pais"
                              @click="habitacion1.paisSeleccionado = ''; resetSelectedPais()"></i>
                            <input class="elipse pointer" type="text" id="paisSeleccionado"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                               @click="filteredListPaises()"
                              v-model="habitacion1.paisSeleccionado" onkeypress="return (event.charCode != 124)" @paste="handlePaste">
                          </div>

                          <div class="card buscadorCard vb" v-if="habitacion1.pais" v-bar>
                            <div>
                              <div class="buscador" v-for="pais in filteredListPaises" :key="pais.id">
                                <p class="mb-1 nombre" @click="[cambiaPais(pais.nombre), habitacion1.pais = false]"
                                  v-html="$options.filters.resalt(pais.nombre, habitacion1.paisSeleccionado)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Estado -->
                        <div class="form-element col-6" v-click-outside="outsideEstado">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.state') }}</label>
                          <div class="contenidoSearch">
                            <i class="search-icons icon-search" v-if="!habitacion1.estado"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion1.estado"
                              @click="habitacion1.estadoSeleccionado = '', filteredListEstado()"></i>
                            <input class="elipse pointer" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                              :disabled="isDisabledEstado" @click="habitacion1.estado = true; filteredListEstado()"
                              v-model="habitacion1.estadoSeleccionado" v-onlyText  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>
                          <div class="card buscadorCard vb" v-if="habitacion1.estado" v-bar>
                            <div>
                              <div class="buscador" v-for="estado in filteredListEstado" :key="estado.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaEstado(estado.stateName), habitacion1.estado = false]"
                                  v-html="$options.filters.resalt(estado.stateName, habitacion1.estadoSeleccionado)">
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Hora de entrada -->
                        <div class="form-element col-6" v-click-outside="outsideHoraIn">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.checkIn') }}<span id="horaEntrada"
                              class="icon-info PC-color--colorBase3"></span></label>
                          <div class="contenidoSearch" @click="[habitacion1.horaIn = true]">
                            <i class="search-icons icon-search" v-if="!habitacion1.horaIn"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion1.horaIn"
                              @click="habitacion1.horaInSeleccionado = '', filteredListHorasIn()"></i>
                            <input class="elipse pointer" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')" readonly
                              @click="filteredListHorasIn()" v-model="habitacion1.horaInSeleccionado">
                          </div>
                          <div class="card buscadorCard vb" v-if="habitacion1.horaIn" v-bar>
                            <div>
                              <div class="buscador" v-for="horaIn in filteredListHorasIn" :key="horaIn.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaHoraIn(horaIn.nombre), habitacion1.horaIn = false]"
                                  v-html="$options.filters.resalt(horaIn.nombre, habitacion1.horaInSeleccionado)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Hora de salida -->
                        <div class="form-element col-6" v-click-outside="outsideHoraOut">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.checkOut') }} <span
                              id="horaSalida" class="icon-info PC-color--colorBase3"></span></label>
                          <div class="contenidoSearch" @click="[habitacion1.horaOut = true]">
                            <i class="search-icons icon-search" v-if="!habitacion1.horaOut"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion1.horaOut"
                              @click="habitacion1.horaOutSeleccionado = '', filteredListHorasOut()"></i>
                            <input class="elipse pointer" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')" readonly
                              @click="filteredListHorasOut()" v-model="habitacion1.horaOutSeleccionado" onkeypress="return (event.charCode != 124)">
                          </div>
                          <div class="card buscadorCard vb" v-if="habitacion1.horaOut" v-bar>
                            <div>
                              <div class="buscador" v-for="horaOut in filteredListHorasOut" :key="horaOut.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaHoraOut(horaOut.nombre), habitacion1.horaOut = false]"
                                  v-html="$options.filters.resalt(horaOut.nombre, habitacion1.horaOutSeleccionado)">
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="col-12 mb-2">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <div v-if="!isUserGeneric" class="col-12 mb-4">
                          <div class="card cardsInfo p-3">
                            <span class="nota">
                              <input class="mt-1" type="checkbox" v-model="saveNewProfileH1" v-onlyText>
                              {{ $t('language.posadasCorporate.reservacionesRegistro.littleBox') }}
                              <a class="notaAzul"
                                @click="privacyNav">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}.</a>
                            </span>
                          </div>
                        </div>

                        <div v-if="isUserGeneric" class="col-12 mb-4">
                          <span>
                            <a class="link pointer bold" @click="privacyNav" onclick="return false;"
                              href="#">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}<i
                                class="icon-report"></i></a>
                          </span>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosContacto'"
                          v-b-toggle.datosAcompanante>
                          <button class="button"
                            @click="[habitacion1.datosContacto = false, formulario1.contacto = true]; setContactDataH1()"
                            :disabled="isDisabledContactoV2">{{ $t('language.posadasCorporate.reservacionesRegistro.continueCompany') }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos del acompañante -->
                  <div class="campos acompanante">
                    <p class="tituloDatos" v-if="habitacion1.datosAcompanante"
                      :class="(habitacion1.iconoActivo == 2) ? 'camposActive' : ''"
                      @click="(habitacion1.iconoActivo == 2) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 2"
                      v-b-toggle="'datosAcompanante'" accordion="my-accordion" role="tabpanel">
                      <i class="icon-user-multiple"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.companionData') }}
                      <i class="navi icon-up" :class="(habitacion1.iconoActivo == 2) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion1.iconoActivo == 2) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion1.datosAcompanante"
                      @click="(habitacion1.iconoActivo == 2) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 2"
                      v-b-toggle="'datosAcompanante'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.companionData') }}
                      <span class="editarDatos"
                        @click="[habitacion1.datosAcompanante = true, formulario1.acompanante = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosAcompanante" accordion="my-accordion" role="tabpanel">
                      <div class="row">

                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.name') }}</label>
                          <input type="text" maxlength="50" name="" v-model="company1Name" class="inputUppercase"
                            v-onlyText  @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.lastName') }}</label>
                          <input type="text" maxlength="30" name="" v-model="company1LastName" class="inputUppercase"
                            v-onlyText  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.secondLastName') }}</label>
                          <input type="text" maxlength="30" name="" v-model="company1SecondLastName"
                            class="inputUppercase" v-onlyText  @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                        </div>

                        <!-- Correo electrónico* -->
                        <div :class="['form-element col-12', isEmailValid()]">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.email') }}</label>
                          <input class="form-control" type="email"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="email1" v-email :class="{ 'is-invalid': (email1.length != 0 && turnText ? true : false) }"  onkeypress="return (event.charCode != 124)">
                          <span class="notas"
                            v-if="turnText">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>

                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo mt-3" v-b-toggle="'datosAcompanante'"
                          v-b-toggle.datosProforma v-if="banSendProformGranted || banReqOpcionales || banSuplement">
                          <button class="button" :disabled="email1.length != 0 && turnText"
                            @click="[habitacion1.datosAcompanante = false, formulario1.acompanante = true]; setCompanyDataH1()">{{ (banSendProformGranted ? $t('language.posadasCorporate.reservacionesRegistro.continueSupplemennts') : $t('language.posadasCorporate.reservacionesRegistro.continueSupplemennt')) }}</button>
                        </div>
                        <div class="col-12 col-lg-6 botonesInfo mt-3" v-b-toggle="'datosProforma'"
                          v-b-toggle.datosRequerimientos
                          v-if="!banSendProformGranted && hideRequirements && !banSuplement && !banReqOpcionales">
                          <!-- v-if="!banSendProformGranted&&hideRequirements&&!banSuplement&&!banReqOpcionales" -->
                          <button class="button" :disabled="email1.length != 0 && turnText"
                            @click="[habitacion1.datosProforma = false, formulario1.proforma = true, habitacion1.datosAcompanante = false, formulario1.acompanante = true]; setCompanyDataH1()">{{ $t('language.posadasCorporate.reservacionesRegistro.continueRequirements') }}</button>
                        </div>
                        <div v-if="showRemainingRooms && !hideRequirements && !banSendProformGranted"
                          class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion2>
                          <button class="button" :disabled="email1.length != 0 && turnText"
                            @click="[habitacion1.datosProforma = false, formulario1.proforma = true, habitacion1.datosAcompanante = false, formulario1.acompanante = true, habitacion1.datosRequerimientos = false, formulario1.requerimientos = true]; setCompanyDataH1()"
                            v-b-toggle.datosAcompanante>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            2</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="campos proforma" v-if="banSendProformGranted || banReqOpcionales || banSuplement">
                    <p class="tituloDatos" v-if="habitacion1.datosProforma"
                      :class="(habitacion1.iconoActivo == 3) ? 'camposActive' : ''"
                      @click="(habitacion1.iconoActivo == 3) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 3"
                      v-b-toggle.datosProforma accordion="my-accordion" role="tabpanel">
                      <i class="icon-report"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.suplementosYConsideraciones') }}
                      <i class="navi icon-up" :class="(habitacion1.iconoActivo == 3) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion1.iconoActivo == 3) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion1.datosProforma"
                      @click="(habitacion1.iconoActivo == 3) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 3"
                      v-b-toggle.datosProforma>
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.suplementosYConsideraciones') }}
                      <span class="editarDatos"
                        @click="[habitacion1.datosProforma = true, formulario1.proforma = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosProforma" accordion="my-accordion" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 mb-4">

                          <label v-if="banSuplement"
                            class="PC-text--semibold">{{ $t('language.posadasCorporate.reservacionConfirmacion.suMan') }}
                          </label>
                          <p class="resort" v-if="banSuplement">
                            <span>{{ descriptionMS }}</span>
                          </p>
                          <p class="resort">
                            <span class="resaltar"></span>
                          </p>

                          <div class="row" v-if="banReqOpcionales">
                            <!-- SOLO DESCOMENTAR ESTA SECCIÓN PARA RESTAURAR EL COMPORTAMIENTO REACTIVO -->

                            <div class="col-12 mb-3 mt-2">
                              <label
                                class="PC-text--semibold">{{ $t('language.posadasCorporate.reservacionesRegistro.suplementosOpcionales') }}</label>
                            </div>
                            <div class="col-xs-12 col-lg-6 mb-2" v-for="(reqOpcional, index) in listRequeOpcionales"
                              :key="'_opcional' + index">
                              <div class="d-flex flex-row">
                                <input class="mt-1 mr-2" type="checkbox" :id="'_RO' + index"
                                  @click="clicCheckBoxReqOpcional($event, reqOpcional, index)"
                                  :checked="validateSuplement(reqOpcional.supplementCode)" v-alphanumeric  onkeypress="return (event.charCode != 124)">
                                <span>
                                  {{ reqOpcional.numSuppleCharged * totalChambres }} {{ reqOpcional.supplementName }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div v-if="banSendProformGranted" class="row mt-2">
                            <div class="col-12 mb-3 mt-2">
                              <label
                                class="PC-text--semibold">{{ $t('language.posadasCorporate.reservacionesRegistro.proforma') }}</label>
                            </div>
                            <div class="col-xs-12 col-lg-6">
                              <div class="d-flex flex-row">
                                <input class="mt-1 mr-2" type="checkbox" v-model="sendProform">
                                <span>
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.sendSu') }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Boton -->
                        <div v-if="true" class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosProforma'"
                          v-b-toggle.datosRequerimientos>
                          <button class="button"
                            @click="[habitacion1.datosProforma = false, formulario1.proforma = true]; sendProformH1()">{{ $t('language.posadasCorporate.reservacionesRegistro.continueRequirements') }}</button>
                        </div>
                        <div v-if="showRemainingRooms && !hideRequirements" class="col-12 col-lg-6 botonesInfo"
                          v-b-toggle.habitacion2>
                          <button class="button"
                            @click="[habitacion1.datosProforma = false, formulario1.proforma = true, habitacion1.datosRequerimientos = false, formulario1.requerimientos = true]; setRequirementsDataH1(); sendProformH1()"
                            v-b-toggle.datosProforma>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            2</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Requerimientos -->
                  <div v-if="hideRequirements" class="campos requerimiento">
                    <p class="tituloDatos" v-if="habitacion1.datosRequerimientos"
                      :class="(habitacion1.iconoActivo == 4) ? 'camposActive' : ''"
                      @click="(habitacion1.iconoActivo == 4) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 4"
                      v-b-toggle="'datosRequerimientos'" accordion="my-accordion" role="tabpanel">
                      <i class="icon-requirements"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <i class="navi icon-up" :class="(habitacion1.iconoActivo == 4) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion1.iconoActivo == 4) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion1.datosRequerimientos"
                      @click="(habitacion1.iconoActivo == 4) ? habitacion1.iconoActivo = 100 : habitacion1.iconoActivo = 4"
                      v-b-toggle="'datosRequerimientos'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <span class="editarDatos"
                        @click="[habitacion1.datosRequerimientos = true, formulario1.requerimientos = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosRequerimientos" accordion="my-accordion" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 mb-4">
                          <p class="resort">
                            {{ $t('language.posadasCorporate.reservacionesRegistro.noAdditionalCost') }}
                          </p>
                        </div>

                        <!-- Preferencias de habitacion -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideRoomPreferents">
                          <div v-if="(listRequeriment.habitacion === null ? false : true)">
                            <label>{{ listRequeriment.habitacion.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion1.roomPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion1.typePreferent"
                                  :class="habitacion1.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly">
                              </span>
                              <span v-else @click="openRoomPreferentType()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion1.typePreferent" readonly="readonly" v-onlyText >
                              </span>
                              <div class="typeRoom card" :class="habitacion1.roomPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allTipo" id="allTipo" v-model="selectAll"
                                    @click="habitacion1.roomPreferences = true" @change="handleType($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeRoomPreferent in habitacion1.typeRoomsPreferents"
                                      :key="typeRoomPreferent.id">
                                      <input type="checkbox" v-model="habitacion1.selected"
                                        :value="typeRoomPreferent.id"
                                        @change="handleTypeSelect($event, typeRoomPreferent.name)">
                                      {{ typeRoomPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAll = false, habitacion1.typePreferent = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion1.typePreferent == '' ? 'deshabilitado' : '']"
                                    @click="habitacion1.roomPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias extras -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsidePreferentsExtra">
                          <div v-if="(listRequeriment.extras === null ? false : true)">
                            <label>{{ listRequeriment.extras.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion1.extraPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion1.typePreferentExtra"
                                  :class="habitacion1.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" v-onlyText >
                              </span>
                              <span v-else @click="openExtraPreferentType()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion1.typePreferentExtra" readonly="readonly" v-onlyText onkeypress="return (event.charCode != 124)">
                              </span>
                              <div class="typeRoom card" :class="habitacion1.extraPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allExtras" id="allExtras" v-model="selectAllExtra"
                                    @click="habitacion1.extraPreferences = true" @change="handleTypeExtra($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeExtraPreferent in habitacion1.typeExtrasPreferents"
                                      :key="typeExtraPreferent.id">
                                      <input type="checkbox" v-model="habitacion1.selectedExtra"
                                        :value="typeExtraPreferent.id"
                                        @change="handleTypeSelectExtra($event, typeExtraPreferent.name)">
                                      {{ typeExtraPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllExtra = false, habitacion1.typePreferentExtra = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion1.typePreferentExtra == '' ? 'deshabilitado' : '']"
                                    @click="habitacion1.extraPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias de piso -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.piso === null ? false : true)">
                            <label>{{ listRequeriment.piso.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                v-model="habitacion1.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.piso.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                v-model="habitacion1.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>

                        <!-- Preferencias de áreas de fumar -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.fumar === null ? false : true)">
                            <label>{{ listRequeriment.fumar.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                v-model="habitacion1.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.fumar.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                v-model="habitacion1.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>

                        <!-- Boton -->
                        <div v-if="showRemainingRooms" class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion2>
                          <button class="button"
                            @click="[habitacion1.datosRequerimientos = false, formulario1.requerimientos = true]; setRequirementsDataH1()"
                            v-b-toggle.datosRequerimientos>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            2</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                </b-collapse>
              </div>

              <!-- Habitacion 2 -->
              <div class="habitacion" v-if="showRemainingRooms">
                <div class="habitacionHeader">
                  <p v-b-toggle="'habitacion2'" class="habitacionTitle"
                    @click="(habitacion2.iconoHabitacion == 1) ? habitacion2.iconoHabitacion = 100 : habitacion2.iconoHabitacion = 1">
                    {{ $t('language.posadasCorporate.reservacionesRegistro.room') }} 2
                    <i class="navi icon-up" :class="(habitacion2.iconoHabitacion == 1) ? '' : 'oculto'"></i>
                    <i class="navi icon-navigate-down" :class="(habitacion2.iconoHabitacion == 1) ? 'oculto' : ''"></i>
                  </p>
                </div>
                <b-collapse class="habitacionBody" id="habitacion2" role="tablist">
                  <div class="text-right">
                    <p class="replicar" @click="replicarInfo">{{ $t('language.posadasCorporate.replicateText.text1') }} 1
                      <i class="icon-doc-copy"></i></p>
                  </div>

                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion2.datosPersonales"
                      :class="(habitacion2.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(habitacion2.iconoActivo == 0) ? habitacion2.iconoActivo = 100 : habitacion2.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH2'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <i class="navi icon-up" :class="(habitacion2.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion2.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion2.datosPersonales"
                      @click="(habitacion2.iconoActivo == 0) ? habitacion2.iconoActivo = 100 : habitacion2.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH2'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <span class="editarDatos"
                        @click="[habitacion2.datosPersonales = true, formulario2.personales = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonalesH2" visible accordion="my-accordionH2"
                      role="tabpanelh2">
                      <div class="row">
                        <!-- Perfiles Existentes -->
                        <div v-if="!isUserGeneric" class="form-element col-12" v-click-outside="outsideSearchH2">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.existingProfiles') }}</label>
                          <div class="contenidoSearch" @click="[habitacion2.buscador = true]">
                            <i class="search-icons icon-search" v-if="!habitacion2.buscador"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion2.buscador"
                              @click="habitacion2.search = '', filteredListH2()"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                              @click="filteredListH2" v-on:input="filteredListH2" v-model="habitacion2.search"
                              v-onlyText v-alphanumeric  onkeypress="return (event.charCode != 124)">
                          </div>


                          <div class="card buscadorCard vb" v-if="habitacion2.buscador" v-bar>
                            <div>
                              <div class="buscador pointer" v-for="perfil in habitacion1.perfilesLista"
                                :key="perfil.id">
                                <p class="mb-1 nombre" @click="[cambiaValueH2(perfil.nombre), habitacion2.buscador = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, habitacion2.search)"></p>
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.name') }}*</label>
                          <input type="text" maxlength="30" v-model="habitacion2.nombres" class="inputUppercase"
                           @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.lastName') }}*</label>
                          <input type="text" maxlength="30" v-model="habitacion2.apellidoP" class="inputUppercase"
                           @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.secondLastName') }}</label>
                          <input type="text" maxlength="30" v-model="habitacion2.apellidoM" class="inputUppercase"
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <div class="col-12">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonalesH2'"
                          v-b-toggle.datosContactoH2>
                          <button class="button"
                            @click="[habitacion2.datosPersonales = false, habitacion2.datosContacto = true, setDataPersonalH2(), formulario2.personales = true]"
                            :disabled="isDisabledHuespedH2">{{ $t('language.posadasCorporate.reservacionesRegistro.continueOne') }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion2.datosContacto"
                      :class="(habitacion2.iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(habitacion2.iconoActivo == 1) ? habitacion2.iconoActivo = 100 : habitacion2.iconoActivo = 1"
                      v-b-toggle="'datosContactoH2'" accordion="my-accordionH2" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <i class="navi icon-up" :class="(habitacion2.iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion2.iconoActivo == 1) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion2.datosContacto"
                      @click="(habitacion2.iconoActivo == 1) ? habitacion2.iconoActivo = 100 : habitacion2.iconoActivo = 1"
                      v-b-toggle="'datosContactoH2'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <span class="editarDatos"
                        @click="[habitacion2.datosContacto = true, formulario2.contacto = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContactoH2" accordion="my-accordionH2" role="tabpanel">
                      <div class="row">

                        <!-- Correo electrónico* -->
                        <div :class="['form-element col-12', isEmailValidRoom2()]">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.email') }}*</label>
                          <input class="form-control" type="email"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="habitacion2.mailContacto" :class="{ 'is-invalid': (turnTextRoom2) }" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          <span class="notas"
                            v-if="turnTextRoom2">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>

                        </div>


                        <div class="col-12 mb-2">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <div v-if="!isUserGeneric" class="col-12 mb-4">
                          <div class="card cardsInfo d-flex flex-row p-3">
                            <input class="mt-1" type="checkbox" v-model="saveNewProfileH2">
                            <span class="nota">
                              {{ $t('language.posadasCorporate.reservacionesRegistro.littleBox') }}
                              <a class="notaAzul"
                                @click="privacyNav()">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}.</a>
                            </span>
                          </div>
                        </div>

                        <div v-if="isUserGeneric" class="col-12 mb-4">
                          <span>
                            <a class="link pointer bold" @click="privacyNav" onclick="return false;"
                              href="#">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}<i
                                class="icon-report"></i></a>
                          </span>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosContactoH2'"
                          v-b-toggle.datosRequerimientosH2 v-if="hideRequirements">
                          <button class="button"
                            @click="[habitacion2.datosContacto = false, formulario2.contacto = true]; setContactDataH2()"
                            :disabled="isDisabledContactoH2">{{ $t('language.posadasCorporate.reservacionesRegistro.continueRequirements') }}</button>
                        </div>
                        <div class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion3
                          v-if="turnRoom3 && showRemainingRooms && !hideRequirements">
                          <button class="button"
                            @click="[habitacion2.datosContacto = false, formulario2.contacto = true, habitacion2.datosRequerimientos = false, formulario2.requerimientos = true]; setContactDataH2()"
                            v-b-toggle.datosContactoH2>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            3</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Requerimientos -->
                  <div v-if="hideRequirements" class="campos requerimiento">
                    <p class="tituloDatos" v-if="habitacion2.datosRequerimientos"
                      :class="(habitacion2.iconoActivo == 4) ? 'camposActive' : ''"
                      @click="(habitacion2.iconoActivo == 4) ? habitacion2.iconoActivo = 100 : habitacion2.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH2 accordion="my-accordionH2" role="tabpanel">
                      <i class="icon-requirements"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <i class="navi icon-up" :class="(habitacion2.iconoActivo == 4) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion2.iconoActivo == 4) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion2.datosRequerimientos"
                      @click="(habitacion2.iconoActivo == 4) ? habitacion2.iconoActivo = 100 : habitacion2.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH2>
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <span class="editarDatos"
                        @click="[habitacion2.datosRequerimientos = true]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosRequerimientosH2" accordion="my-accordionH2" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 mb-4">
                          <p class="resort">
                            {{ $t('language.posadasCorporate.reservacionesRegistro.noAdditionalCost') }}
                          </p>
                        </div>

                        <!-- Preferencias de habitacion -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideRoomPreferentsH2">
                          <div v-if="(listRequeriment.habitacion === null ? false : true)">
                            <label>{{ listRequeriment.habitacion.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion2.roomPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion2.typePreferent"
                                  :class="habitacion2.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" >
                              </span>
                              <span v-else @click="openRoomPreferentTypeH2()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion2.typePreferent" readonly="readonly" >
                              </span>
                              <div class="typeRoom card" :class="habitacion2.roomPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allTiposH2" id="allTiposH2" v-model="selectAllH2"
                                    @click="habitacion2.roomPreferences = true" @change="handleTypeH2($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeRoomPreferent in habitacion2.typeRoomsPreferents"
                                      :key="typeRoomPreferent.id">
                                      <input type="checkbox" v-model="habitacion2.selected"
                                        :value="typeRoomPreferent.id"
                                        @change="handleTypeSelectH2($event, typeRoomPreferent.name)"  v-alphanumeric onkeypress="return (event.charCode != 124)">
                                      {{ typeRoomPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllH2 = false, habitacion2.typePreferent = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion2.typePreferent == '' ? 'deshabilitado' : '']"
                                    @click="habitacion2.roomPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias extras -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsidePreferentsExtraH2">
                          <div v-if="(listRequeriment.extras === null ? false : true)">
                            <label>{{ listRequeriment.extras.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion2.extraPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion2.typePreferentExtra"
                                  :class="habitacion2.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" >
                              </span>
                              <span v-else @click="openExtraPreferentTypeH2()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion2.typePreferentExtra" readonly="readonly" >
                              </span>
                              <div class="typeRoom card" :class="habitacion2.extraPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allExtrasH2" id="allExtrasH2" v-model="selectAllExtraH2"
                                    @click="habitacion2.extraPreferences = true" @change="handleTypeExtraH2($event)"  >
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences')  }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeExtraPreferent in habitacion2.typeExtrasPreferents"
                                      :key="typeExtraPreferent.id">
                                      <input type="checkbox" v-model="habitacion2.selectedExtra"
                                        :value="typeExtraPreferent.id"
                                        @change="handleTypeSelectExtraH2($event, typeExtraPreferent.name)"  >
                                      {{ typeExtraPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllExtraH2 = false, habitacion2.typePreferentExtra = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion2.typePreferentExtra == '' ? 'deshabilitado' : '']"
                                    @click="habitacion2.extraPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias de piso -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.piso === null ? false : true)">
                            <label>{{ listRequeriment.piso.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio"
                                :value="listRequeriment.piso.requirementResponseList[0].requirementCode" class="hidden"
                                :id="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                v-model="habitacion2.pickedPiso"  >
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[0].requirementName }}
                              </span> <!--  -->
                            </label>
                            <label v-if="listRequeriment.piso.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <!-- Delete FOR -->
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                :value="listRequeriment.piso.requirementResponseList[1].requirementCode" class="hidden"
                                v-model="habitacion2.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[1].requirementName }}
                              </span> <!--  -->
                            </label>
                          </div>
                        </div>

                        <!-- Preferencias de áreas de fumar -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.fumar === null ? false : true)">
                            <label>{{ listRequeriment.fumar.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                v-model="habitacion2.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.fumar.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                v-model="habitacion2.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>
                        <div class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion3 v-if="turnRoom3">
                          <button class="button"
                            @click="[habitacion2.datosRequerimientos = false, formulario2.requerimientos = true]; setRequirementsDataH2()"
                            v-b-toggle.datosRequerimientosH2>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            3</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                </b-collapse>

              </div>
              <!-- HERE FINISHES ROOM #2 -->

              <!-------------------- HERE STARTS ROOM #3 ------------------------------------------------------->
              <div class="habitacion" v-if="turnRoom3">
                <div class="habitacionHeader">
                  <p v-b-toggle="'habitacion3'" class="habitacionTitle"
                    @click="(habitacion3.iconoHabitacion == 1) ? habitacion3.iconoHabitacion = 100 : habitacion3.iconoHabitacion = 1">
                    {{ $t('language.posadasCorporate.reservacionesRegistro.room') }} 3
                    <i class="navi icon-up" :class="(habitacion3.iconoHabitacion == 1) ? '' : 'oculto'"></i>
                    <i class="navi icon-navigate-down" :class="(habitacion3.iconoHabitacion == 1) ? 'oculto' : ''"></i>
                  </p>
                </div>
                <b-collapse class="habitacionBody" id="habitacion3" role="tablist">
                  <div class="text-right">
                    <p class="replicar" @click="replicarInfo3">{{ $t('language.posadasCorporate.replicateText.text1') }} 1
                      <i class="icon-doc-copy"></i></p>
                  </div>
                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion3.datosPersonales"
                      :class="(habitacion3.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(habitacion3.iconoActivo == 0) ? habitacion3.iconoActivo = 100 : habitacion3.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH3'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <i class="navi icon-up" :class="(habitacion3.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion3.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion3.datosPersonales"
                      @click="(habitacion3.iconoActivo == 0) ? habitacion3.iconoActivo = 100 : habitacion3.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH3'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <span class="editarDatos"
                        @click="[habitacion3.datosPersonales = true, formulario3.personales = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonalesH3" visible accordion="my-accordionH3"
                      role="tabpanelh3">
                      <div class="row">
                        <!-- Perfiles Existentes -->
                        <div v-if="!isUserGeneric" class="form-element col-12 col-lg-12"
                          v-click-outside="outsideSearchH3">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.existingProfiles') }}</label>
                          <div class="contenidoSearch" @click="[habitacion3.buscador = true]">
                            <i class="search-icons icon-search" v-if="!habitacion3.buscador"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion3.buscador"
                              @click="habitacion3.search = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                              @click="filteredListH3" v-on:input="filteredListH3" v-model="habitacion3.search"
                              v-onlyText  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>

                          <div class="card buscadorCard vb" v-if="habitacion3.buscador" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in habitacion1.perfilesLista" :key="perfil.id">
                                <p class="mb-1 nombre" @click="[cambiaValueH3(perfil.nombre), habitacion3.buscador = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, habitacion3.search)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.name') }}*</label>
                          <input type="text" maxlength="50" v-model="habitacion3.nombres" class="inputUppercase"
                           @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.lastName') }}*</label>
                          <input type="text" maxlength="30" v-model="habitacion3.apellidoP" class="inputUppercase"
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.secondLastName') }}</label>
                          <input type="text" maxlength="30" v-model="habitacion3.apellidoM" class="inputUppercase"
                           @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <div class="col-12">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonalesH3'"
                          v-b-toggle.datosContactoH3>
                          <button class="button"
                            @click="[habitacion3.datosPersonales = false, habitacion3.datosContacto = true, formulario3.personales = true, setDataPersonalH3()]"
                            :disabled="isDisabledHuespedH3">{{ $t('language.posadasCorporate.reservacionesRegistro.continueOne') }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion3.datosContacto"
                      :class="(habitacion3.iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(habitacion3.iconoActivo == 1) ? habitacion3.iconoActivo = 100 : habitacion3.iconoActivo = 1"
                      v-b-toggle="'datosContactoH3'" accordion="my-accordionH3" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <i class="navi icon-up" :class="(habitacion3.iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion3.iconoActivo == 1) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion3.datosContacto"
                      @click="(habitacion3.iconoActivo == 1) ? habitacion3.iconoActivo = 100 : habitacion3.iconoActivo = 1"
                      v-b-toggle="'datosContactoH3'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <span class="editarDatos"
                        @click="[habitacion3.datosContacto = true, formulario3.contacto = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContactoH3" accordion="my-accordionH3" role="tabpanel">
                      <div class="row">

                        <!-- Correo electrónico* -->


                        <div :class="['form-element col-12', isEmailValidRoom3()]">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.email') }}*</label>
                          <input class="form-control" type="email"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="habitacion3.mailContacto" v-email :class="{ 'is-invalid': (turnTextRoom3) }"  @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                          <span class="notas"
                            v-if="turnTextRoom3">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>

                        </div>

      <div class="col-12 mb-2">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <div v-if="!isUserGeneric" class="col-12 mb-4">
                          <div class="card cardsInfo d-flex flex-row p-3">
                            <input class="mt-1" type="checkbox" v-model="saveNewProfileH3">
                            <span class="nota">
                              {{ $t('language.posadasCorporate.reservacionesRegistro.littleBox') }}
                              <a class="notaAzul"
                                @click="privacyNav()">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}.</a>
                            </span>
                          </div>
                        </div>

                        <div v-if="isUserGeneric" class="col-12 mb-4">
                          <span>
                            <a class="link pointer bold" @click="privacyNav" onclick="return false;"
                              href="#">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}<i
                                class="icon-report"></i></a>
                          </span>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosContactoH3'"
                          v-b-toggle.datosRequerimientosH3 v-if="hideRequirements">
                          <button class="button"
                            @click="[habitacion3.datosContacto = false, formulario3.contacto = true]; setContactDataH3()"
                            :disabled="isDisabledContactoH3">{{ $t('language.posadasCorporate.reservacionesRegistro.continueRequirements') }}</button>
                        </div>
                        <div class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion4
                          v-if="turnRoom4 && !hideRequirements">
                          <button class="button"
                            @click="[habitacion3.datosContacto = false, formulario3.contacto = true, habitacion3.datosRequerimientos = false, formulario3.requerimientos = true]; setContactDataH3()"
                            v-b-toggle.datosContactoH3>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            4</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Requerimientos -->
                  <div v-if="hideRequirements" class="campos requerimiento">
                    <p class="tituloDatos" v-if="habitacion3.datosRequerimientos"
                      :class="(habitacion3.iconoActivo == 4) ? 'camposActive' : ''"
                      @click="(habitacion3.iconoActivo == 4) ? habitacion3.iconoActivo = 100 : habitacion3.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH3 accordion="my-accordionH3" role="tabpanel">
                      <i class="icon-requirements"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <i class="navi icon-up" :class="(habitacion3.iconoActivo == 4) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion3.iconoActivo == 4) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion3.datosRequerimientos"
                      @click="(habitacion3.iconoActivo == 4) ? habitacion3.iconoActivo = 100 : habitacion3.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH3>
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <span class="editarDatos"
                        @click="[habitacion3.datosRequerimientos = true]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosRequerimientosH3" accordion="my-accordionH3" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 mb-4">
                          <p class="resort">
                            {{ $t('language.posadasCorporate.reservacionesRegistro.noAdditionalCost') }}
                          </p>
                        </div>

                        <!-- Ajuste selects -->


                        <!-- Preferencias de habitacion -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideRoomPreferentsH3">
                          <div v-if="(listRequeriment.habitacion === null ? false : true)">
                            <label>{{ listRequeriment.habitacion.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion3.roomPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion3.typePreferent"
                                  :class="habitacion3.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" >
                              </span>
                              <span v-else @click="openRoomPreferentTypeH3()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion3.typePreferent" readonly="readonly" >
                              </span>
                              <div class="typeRoom card" :class="habitacion3.roomPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allTiposH3" id="allTiposH3" v-model="selectAllH3"
                                    @click="habitacion3.roomPreferences = true" @change="handleTypeH3($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeRoomPreferent in habitacion3.typeRoomsPreferents"
                                      :key="typeRoomPreferent.id">
                                      <input type="checkbox" v-model="habitacion3.selected"
                                        :value="typeRoomPreferent.id"
                                        @change="handleTypeSelectH3($event, typeRoomPreferent.name)">
                                      {{ typeRoomPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllH3 = false, habitacion3.typePreferent = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion3.typePreferent == '' ? 'deshabilitado' : '']"
                                    @click="habitacion3.roomPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias extras -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsidePreferentsExtraH3">
                          <div v-if="(listRequeriment.extras === null ? false : true)">
                            <label>{{ listRequeriment.extras.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion3.extraPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion3.typePreferentExtra"
                                  :class="habitacion3.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" v-onlyText>
                              </span>
                              <span v-else @click="openExtraPreferentTypeH3()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion3.typePreferentExtra" readonly="readonly" v-onlyText>
                              </span>
                              <div class="typeRoom card" :class="habitacion3.extraPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allExtrasH3" id="allExtrasH3" v-model="selectAllExtraH3"
                                    @click="habitacion3.extraPreferences = true" @change="handleTypeExtraH3($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeExtraPreferent in habitacion3.typeExtrasPreferents"
                                      :key="typeExtraPreferent.id">
                                      <input type="checkbox" v-model="habitacion3.selectedExtra"
                                        :value="typeExtraPreferent.id"
                                        @change="handleTypeSelectExtraH2($event, typeExtraPreferent.name)">
                                      {{ typeExtraPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllExtraH3 = false, habitacion3.typePreferentExtra = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion3.typePreferentExtra == '' ? 'deshabilitado' : '']"
                                    @click="habitacion3.extraPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Ajuste selects -->





                        <!-- Preferencias de piso -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.piso === null ? false : true)">
                            <label>{{ listRequeriment.piso.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                v-model="habitacion3.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.piso.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                v-model="habitacion3.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>



                        <!-- Preferencias de áreas de fumar -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.fumar === null ? false : true)">
                            <label>{{ listRequeriment.fumar.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                v-model="habitacion3.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.fumar.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                v-model="habitacion3.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion4 v-if="turnRoom4">
                          <button class="button"
                            @click="[habitacion3.datosRequerimientos = false, formulario3.requerimientos = true]; setRequirementsDataH3()"
                            v-b-toggle.datosRequerimientosH3>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            4</button>
                        </div>


                      </div>
                    </b-collapse>
                  </div>

                </b-collapse>

              </div>
              <!-------------------------- HERE FINISHES ROOM #3 --------------------------------------------------->
              <!------------------------------------ HERE STARTS ROOM #4 --------------------------------------------------------------------->
              <div class="habitacion" v-if="turnRoom4">
                <div class="habitacionHeader">
                  <p v-b-toggle="'habitacion4'" class="habitacionTitle"
                    @click="(habitacion4.iconoHabitacion == 1) ? habitacion4.iconoHabitacion = 100 : habitacion4.iconoHabitacion = 1">
                    {{ $t('language.posadasCorporate.reservacionesRegistro.room') }} 4
                    <i class="navi icon-up" :class="(habitacion4.iconoHabitacion == 1) ? '' : 'oculto'"></i>
                    <i class="navi icon-navigate-down" :class="(habitacion4.iconoHabitacion == 1) ? 'oculto' : ''"></i>
                  </p>
                </div>
                <b-collapse class="habitacionBody" id="habitacion4" role="tablist">
                  <div class="text-right">
                    <p class="replicar" @click="replicarInfo4">{{ $t('language.posadasCorporate.replicateText.text1') }} 1
                      <i class="icon-doc-copy"></i></p>
                  </div>
                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion4.datosPersonales"
                      :class="(habitacion4.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(habitacion4.iconoActivo == 0) ? habitacion4.iconoActivo = 100 : habitacion4.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH4'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <i class="navi icon-up" :class="(habitacion4.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion4.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion4.datosPersonales"
                      @click="(habitacion4.iconoActivo == 0) ? habitacion4.iconoActivo = 100 : habitacion4.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH4'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <span class="editarDatos"
                        @click="[habitacion4.datosPersonales = true, formulario4.personales = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonalesH4" visible accordion="my-accordionH4"
                      role="tabpanelh4">
                      <div class="row">
                        <!-- Perfiles Existentes -->
                        <div v-if="!isUserGeneric" class="form-element col-12 col-lg-12"
                          v-click-outside="outsideSearchH4">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.existingProfiles') }}</label>
                          <div class="contenidoSearch" @click="[habitacion4.buscador = true]">
                            <i class="search-icons icon-search" v-if="!habitacion4.buscador"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion4.buscador"
                              @click="habitacion4.search = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                              @click="filteredListH4" v-on:input="filteredListH4" v-model="habitacion4.search"
                              @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>

                          <div class="card buscadorCard vb" v-if="habitacion4.buscador" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in habitacion1.perfilesLista" :key="perfil.id">
                                <p class="mb-1 nombre" @click="[cambiaValueH4(perfil.nombre), habitacion4.buscador = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, habitacion4.search)"></p>
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.name') }}*</label>
                          <input type="text" maxlength="50" v-model="habitacion4.nombres" class="inputUppercase"
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.lastName') }}*</label>
                          <input type="text" maxlength="30" v-model="habitacion4.apellidoP" class="inputUppercase"
                             @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.secondLastName') }}</label>
                          <input type="text" maxlength="30" v-model="habitacion4.apellidoM" class="inputUppercase"
                           @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <div class="col-12">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonalesH4'"
                          v-b-toggle.datosContactoH4>
                          <button class="button"
                            @click="[habitacion4.datosPersonales = false, habitacion4.datosContacto = true, formulario4.personales = true, setDataPersonalH4()]"
                            :disabled="isDisabledHuespedH4">{{ $t('language.posadasCorporate.reservacionesRegistro.continueOne') }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion4.datosContacto"
                      :class="(habitacion4.iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(habitacion4.iconoActivo == 1) ? habitacion4.iconoActivo = 100 : habitacion4.iconoActivo = 1"
                      v-b-toggle="'datosContactoH4'" accordion="my-accordionH4" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <i class="navi icon-up" :class="(habitacion4.iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion4.iconoActivo == 1) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion4.datosContacto"
                      @click="(habitacion4.iconoActivo == 1) ? habitacion4.iconoActivo = 100 : habitacion4.iconoActivo = 1"
                      v-b-toggle="'datosContactoH4'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <span class="editarDatos"
                        @click="[habitacion4.datosContacto = true, formulario4.contacto = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContactoH4" accordion="my-accordionH4" role="tabpanel">
                      <div class="row">

                        <!-- Correo electrónico* -->




                        <div :class="['form-element col-12', isEmailValidRoom4()]">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.email') }}*</label>
                          <input class="form-control" type="email"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="habitacion4.mailContacto" v-email :class="{ 'is-invalid': (turnTextRoom4) }" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          <span class="notas"
                            v-if="turnTextRoom4">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>

                        </div>


                        <div class="col-12 mb-2">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <div v-if="!isUserGeneric" class="col-12 mb-4">
                          <div class="card cardsInfo d-flex flex-row p-3">
                            <input class="mt-1" type="checkbox" v-model="saveNewProfileH4">
                            <span class="nota">
                              {{ $t('language.posadasCorporate.reservacionesRegistro.littleBox') }}
                              <a class="notaAzul"
                                @click="privacyNav()">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}.</a>
                            </span>
                          </div>
                        </div>

                        <div v-if="isUserGeneric" class="col-12 mb-4">
                          <span>
                            <a class="link pointer bold" @click="privacyNav" onclick="return false;"
                              href="#">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}<i
                                class="icon-report"></i></a>
                          </span>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosContactoH4'"
                          v-b-toggle.datosRequerimientosH4 v-if="hideRequirements">
                          <button class="button"
                            @click="[habitacion4.datosContacto = false, formulario4.contacto = true]; setContactDataH4()"
                            :disabled="isDisabledContactoH4">{{ $t('language.posadasCorporate.reservacionesRegistro.continueRequirements') }}</button>
                        </div>
                        <div class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion5
                          v-if="turnRoom5 && !hideRequirements">
                          <button class="button"
                            @click="[habitacion4.datosContacto = false, formulario4.contacto = true, habitacion4.datosRequerimientos = false, formulario4.requerimientos = true]; setContactDataH4()"
                            v-b-toggle.datosContactoH4>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            5</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Requerimientos -->
                  <div v-if="hideRequirements" class="campos requerimiento">
                    <p class="tituloDatos" v-if="habitacion4.datosRequerimientos"
                      :class="(habitacion4.iconoActivo == 4) ? 'camposActive' : ''"
                      @click="(habitacion4.iconoActivo == 4) ? habitacion4.iconoActivo = 100 : habitacion4.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH4 accordion="my-accordionH4" role="tabpanel">
                      <i class="icon-requirements"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <i class="navi icon-up" :class="(habitacion4.iconoActivo == 4) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion4.iconoActivo == 4) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion4.datosRequerimientos"
                      @click="(habitacion4.iconoActivo == 4) ? habitacion4.iconoActivo = 100 : habitacion4.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH4>
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <span class="editarDatos"
                        @click="[habitacion4.datosRequerimientos = true]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosRequerimientosH4" accordion="my-accordionH4" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 mb-4">
                          <p class="resort">
                            {{ $t('language.posadasCorporate.reservacionesRegistro.noAdditionalCost') }}
                          </p>
                        </div>

                        <!-- Ajuste de selects -->
                        <!-- Preferencias de habitacion -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideRoomPreferentsH4">
                          <div v-if="(listRequeriment.habitacion === null ? false : true)">
                            <label>{{ listRequeriment.habitacion.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion4.roomPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion4.typePreferent"
                                  :class="habitacion4.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                              </span>
                              <span v-else @click="openRoomPreferentTypeH4()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion4.typePreferent" readonly="readonly" v-onlyText v-alphanumeric  onkeypress="return (event.charCode != 124)">
                              </span>
                              <div class="typeRoom card" :class="habitacion4.roomPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allTiposH4" id="allTiposH4" v-model="selectAllH4"
                                    @click="habitacion4.roomPreferences = true" @change="handleTypeH4($event)" >
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeRoomPreferent in habitacion4.typeRoomsPreferents"
                                      :key="typeRoomPreferent.id">
                                      <input type="checkbox" v-model="habitacion4.selected"
                                        :value="typeRoomPreferent.id"
                                        @change="handleTypeSelectH4($event, typeRoomPreferent.name)">
                                      {{ typeRoomPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllH4 = false, habitacion4.typePreferent = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion4.typePreferent == '' ? 'deshabilitado' : '']"
                                    @click="habitacion4.roomPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias extras -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsidePreferentsExtraH4">
                          <div v-if="(listRequeriment.extras === null ? false : true)">
                            <label>{{ listRequeriment.extras.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion4.extraPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion4.typePreferentExtra"
                                  :class="habitacion4.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" v-onlyText>
                              </span>
                              <span v-else @click="openExtraPreferentTypeH4()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion4.typePreferentExtra" readonly="readonly" v-onlyText>
                              </span>
                              <div class="typeRoom card" :class="habitacion4.extraPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allExtrasH4" id="allExtrasH4" v-model="selectAllExtraH4"
                                    @click="habitacion4.extraPreferences = true" @change="handleTypeExtraH4($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeExtraPreferent in habitacion4.typeExtrasPreferents"
                                      :key="typeExtraPreferent.id">
                                      <input type="checkbox" v-model="habitacion4.selectedExtra"
                                        :value="typeExtraPreferent.id"
                                        @change="handleTypeSelectExtraH4($event, typeExtraPreferent.name)">
                                      {{ typeExtraPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllExtraH4 = false, habitacion4.typePreferentExtra = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion4.typePreferentExtra == '' ? 'deshabilitado' : '']"
                                    @click="habitacion4.extraPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Ajuste de selects -->
                        <!-- Preferencias de piso -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.piso === null ? false : true)">
                            <label>{{ listRequeriment.piso.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                v-model="habitacion4.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.piso.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                v-model="habitacion4.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>

                        <!-- Preferencias de áreas de fumar -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.fumar === null ? false : true)">
                            <label>{{ listRequeriment.fumar.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                v-model="habitacion4.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.fumar.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                v-model="habitacion4.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>
                        <div class="col-12 col-lg-6 botonesInfo mt-4" v-b-toggle.habitacion5 v-if="turnRoom5">
                          <button class="button"
                            @click="[habitacion4.datosRequerimientos = false, formulario4.requerimientos = true]; setRequirementsDataH4()"
                            v-b-toggle.datosRequerimientosH4>{{ $t('language.posadasCorporate.reservacionesRegistro.continueRoom') }}
                            5</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                </b-collapse>

              </div>


              <!------------------------------------ HERE FINISH ROOM #4 --------------------------------------------------------------------->
              <!------------------------------------ HERE STARTS ROOM #5 --------------------------------------------------------------------->
              <div class="habitacion" v-if="turnRoom5">
                <div class="habitacionHeader">
                  <p v-b-toggle="'habitacion5'" class="habitacionTitle"
                    @click="(habitacion5.iconoHabitacion == 1) ? habitacion5.iconoHabitacion = 100 : habitacion5.iconoHabitacion = 1">
                    {{ $t('language.posadasCorporate.reservacionesRegistro.room') }} 5
                    <i class="navi icon-up" :class="(habitacion5.iconoHabitacion == 1) ? '' : 'oculto'"></i>
                    <i class="navi icon-navigate-down" :class="(habitacion5.iconoHabitacion == 1) ? 'oculto' : ''"></i>
                  </p>
                </div>
                <b-collapse class="habitacionBody" id="habitacion5" role="tablist">
                  <div class="text-right">
                    <p class="replicar" @click="replicarInfo5">{{ $t('language.posadasCorporate.replicateText.text1') }} 1
                      <i class="icon-doc-copy"></i></p>
                  </div>
                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion5.datosPersonales"
                      :class="(habitacion5.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(habitacion5.iconoActivo == 0) ? habitacion5.iconoActivo = 100 : habitacion5.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH5'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <i class="navi icon-up" :class="(habitacion5.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion5.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion5.datosPersonales"
                      @click="(habitacion5.iconoActivo == 0) ? habitacion5.iconoActivo = 100 : habitacion5.iconoActivo = 0"
                      v-b-toggle="'datosPersonalesH5'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.personalData') }}
                      <span class="editarDatos"
                        @click="[habitacion5.datosPersonales = true, formulario5.personales = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonalesH5" visible accordion="my-accordionH5"
                      role="tabpanelh5">
                      <div class="row">
                        <!-- Perfiles Existentes -->
                        <div v-if="!isUserGeneric" class="form-element col-12 col-lg-12"
                          v-click-outside="outsideSearchH5">
                          <label>{{ $t('language.posadasCorporate.reservacionesRegistro.existingProfiles') }}</label>
                          <div class="contenidoSearch" @click="[habitacion5.buscador = true]">
                            <i class="search-icons icon-search" v-if="!habitacion5.buscador"></i>
                            <i class="search-icons icon-close pointer" v-if="habitacion5.buscador"
                              @click="habitacion5.search = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                              @click="filteredListH5" v-on:input="filteredListH5" v-model="habitacion5.search"
                              @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>

                          <div class="card buscadorCard vb" v-if="habitacion5.buscador" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in habitacion1.perfilesLista" :key="perfil.id">
                                <p class="mb-1 nombre" @click="[cambiaValueH5(perfil.nombre), habitacion5.buscador = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, habitacion5.search)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.name') }}*</label>
                          <input type="text" maxlength="50" v-model="habitacion5.nombres" class="inputUppercase"
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.lastName') }}*</label>
                          <input type="text" maxlength="30" v-model="habitacion5.apellidoP" class="inputUppercase"
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.secondLastName') }}</label>
                          <input type="text" maxlength="30" v-model="habitacion5.apellidoM" class="inputUppercase"
                           @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <div class="col-12">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonalesH5'"
                          v-b-toggle.datosContactoH5>
                          <button class="button"
                            @click="[habitacion5.datosPersonales = false, habitacion5.datosContacto = true, formulario5.personales = true, setDataPersonalH5()]"
                            :disabled="isDisabledHuespedH5">{{ $t('language.posadasCorporate.reservacionesRegistro.continueOne') }}</button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="habitacion5.datosContacto"
                      :class="(habitacion5.iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(habitacion5.iconoActivo == 1) ? habitacion5.iconoActivo = 100 : habitacion5.iconoActivo = 1"
                      v-b-toggle="'datosContactoH5'" accordion="my-accordionH5" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <i class="navi icon-up" :class="(habitacion5.iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion5.iconoActivo == 1) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion5.datosContacto"
                      @click="(habitacion5.iconoActivo == 1) ? habitacion5.iconoActivo = 100 : habitacion5.iconoActivo = 1"
                      v-b-toggle="'datosContactoH5'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.dataContact') }}
                      <span class="editarDatos"
                        @click="[habitacion5.datosContacto = true, formulario5.contacto = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContactoH5" accordion="my-accordionH5" role="tabpanel">
                      <div class="row">

                        <!-- Correo electrónico* -->



                        <div :class="['form-element col-12', isEmailValidRoom5()]">
                          <label for="">{{ $t('language.posadasCorporate.reservacionesRegistro.email') }}*</label>
                          <input class="form-control" type="email"
                            :placeholder="$t('language.posadasCorporate.reservacionesRegistro.exampleEmail')"
                            v-model="habitacion5.mailContacto" v-email :class="{ 'is-invalid': (turnTextRoom5) }">
                          <span class="notas"
                            v-if="turnTextRoom5">{{ $t('language.posadasCorporate.reservacionesRegistro.invalidEmail') }}</span>

                        </div>


                        <div class="col-12 mb-2">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.reservacionesRegistro.requiredFields') }}</label>
                        </div>

                        <div v-if="!isUserGeneric" class="col-12 mb-4">
                          <div class="card cardsInfo d-flex flex-row p-3">
                            <input class="mt-1" type="checkbox" v-model="saveNewProfileH5">
                            <span class="nota">
                              {{ $t('language.posadasCorporate.reservacionesRegistro.littleBox') }}
                              <a class="notaAzul"
                                @click="privacyNav()">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}.</a>
                            </span>
                          </div>
                        </div>

                        <div v-if="isUserGeneric" class="col-12 mb-4">
                          <span>
                            <a class="link pointer bold" @click="privacyNav" onclick="return false;"
                              href="#">{{ $t('language.posadasCorporate.reservacionesRegistro.privacy') }}<i
                                class="icon-report"></i></a>
                          </span>
                        </div>

                        <!-- Boton -->
                        <div class="col-12 col-lg-6 botonesInfo" v-b-toggle="'datosContactoH5'"
                          v-b-toggle.datosRequerimientosH5 v-if="hideRequirements">
                          <button class="button"
                            @click="[habitacion5.datosContacto = false, formulario5.contacto = true]; setContactDataH5()"
                            :disabled="isDisabledContactoH5">{{ $t('language.posadasCorporate.reservacionesRegistro.continueRequirements') }}</button>
                        </div>

                      </div>
                    </b-collapse>
                  </div>

                  <!-- Requerimientos -->
                  <div v-if="hideRequirements" class="campos requerimiento">
                    <p class="tituloDatos" v-if="habitacion5.datosRequerimientos"
                      :class="(habitacion5.iconoActivo == 4) ? 'camposActive' : ''"
                      @click="(habitacion5.iconoActivo == 4) ? habitacion5.iconoActivo = 100 : habitacion5.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH5 accordion="my-accordionH3" role="tabpanel">
                      <i class="icon-requirements"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <i class="navi icon-up" :class="(habitacion5.iconoActivo == 4) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(habitacion5.iconoActivo == 4) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!habitacion5.datosRequerimientos"
                      @click="(habitacion5.iconoActivo == 4) ? habitacion5.iconoActivo = 100 : habitacion5.iconoActivo = 4"
                      v-b-toggle.datosRequerimientosH5>
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.reservacionesRegistro.requires') }}
                      <span class="editarDatos"
                        @click="[habitacion5.datosRequerimientos = true]">{{ $t('language.posadasCorporate.reservacionesRegistro.edit') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosRequerimientosH5" accordion="my-accordionH5" role="tabpanel">
                      <div class="row">

                        <div class="form-element col-12 mb-4">
                          <p class="resort">
                            {{ $t('language.posadasCorporate.reservacionesRegistro.noAdditionalCost') }}
                          </p>
                        </div>

                        <!-- Ajustes select -->


                        <!-- Preferencias de habitacion -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideRoomPreferentsH5">
                          <div v-if="(listRequeriment.habitacion === null ? false : true)">
                            <label>{{ listRequeriment.habitacion.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion5.roomPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion5.typePreferent"
                                  :class="habitacion5.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" v-onlyText>
                              </span>
                              <span v-else @click="openRoomPreferentTypeH5()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion5.typePreferent" readonly="readonly" v-onlyText>
                              </span>
                              <div class="typeRoom card" :class="habitacion5.roomPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allTiposH5" id="allTiposH5" v-model="selectAllH5"
                                    @click="habitacion5.roomPreferences = true" @change="handleTypeH5($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeRoomPreferent in habitacion5.typeRoomsPreferents"
                                      :key="typeRoomPreferent.id">
                                      <input type="checkbox" v-model="habitacion5.selected"
                                        :value="typeRoomPreferent.id"
                                        @change="handleTypeSelectH5($event, typeRoomPreferent.name)">
                                      {{ typeRoomPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllH5 = false, habitacion5.typePreferent = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion5.typePreferent == '' ? 'deshabilitado' : '']"
                                    @click="habitacion5.roomPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Preferencias extras -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsidePreferentsExtraH5">
                          <div v-if="(listRequeriment.extras === null ? false : true)">
                            <label>{{ listRequeriment.extras.requirementType }}</label>
                            <div class="__addIcon">
                              <span v-if="device == 'desktop'" @click="habitacion5.extraPreferences = false">
                                <input type="text" class="inputTypeHabitaciones"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion5.typePreferentExtra"
                                  :class="habitacion5.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''"
                                  readonly="readonly" v-onlyText>
                              </span>
                              <span v-else @click="openExtraPreferentTypeH5()">
                                <input type="text" class="inputTypeHabitaciones elipse"
                                  :placeholder="$t('language.posadasCorporate.reservacionesRegistro.selectA')"
                                  v-model="habitacion5.typePreferentExtra" readonly="readonly" v-onlyText>
                              </span>
                              <div class="typeRoom card" :class="habitacion5.extraPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allExtrasH5" id="allExtrasH5" v-model="selectAllExtraH5"
                                    @click="habitacion5.extraPreferences = true" @change="handleTypeExtraH5($event)">
                                  {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences') }}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block" v-for="typeExtraPreferent in habitacion5.typeExtrasPreferents"
                                      :key="typeExtraPreferent.id">
                                      <input type="checkbox" v-model="habitacion5.selectedExtra"
                                        :value="typeExtraPreferent.id"
                                        @change="handleTypeSelectExtraH5($event, typeExtraPreferent.name)">
                                      {{ typeExtraPreferent.name }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                    @click="[selectAllExtraH5 = false, habitacion5.typePreferentExtra = '']">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                    :class="[habitacion5.typePreferentExtra == '' ? 'deshabilitado' : '']"
                                    @click="habitacion5.extraPreferences = true">
                                    {{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Ajustes select -->


                        <!-- Preferencias de piso -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.piso === null ? false : true)">
                            <label>{{ listRequeriment.piso.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[0].requirementCode"
                                v-model="habitacion5.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.piso.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.piso.requirementResponseList[1].requirementCode"
                                v-model="habitacion5.pickedPiso">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.piso.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>

                        <!-- Preferencias de áreas de fumar -->
                        <div class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment.fumar === null ? false : true)">
                            <label>{{ listRequeriment.fumar.requirementType }}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode"
                                v-model="habitacion5.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[0].requirementName }}</span>
                            </label>
                            <label v-if="listRequeriment.fumar.requirementResponseList.length > 1"
                              class="col-6 pl-0 radio">
                              <input type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode"
                                v-model="habitacion5.pickedFumar">
                              <span class="label"></span><span
                                class="moneda">{{ listRequeriment.fumar.requirementResponseList[1].requirementName }}</span>
                            </label>
                          </div>
                        </div>




                      </div>
                    </b-collapse>
                  </div>

                </b-collapse>

              </div>



              <!------------------------------------ HERE FINISH ROOM #5 --------------------------------------------------------------------->
            </div>
            <!-- Botones -->
            <div class="row botones">
              <div class="col-12 col-lg-6 botonesInfo order-2 order-lg-1">
                <router-link to="/" tag="button" class="secondary-button">
                  {{ $t('language.posadasCorporate.reservacionesRegistro.back') }}
                </router-link>
              </div>
              <div v-if="showRemainingRooms == false && turnRoom3 == false && turnRoom4 == false && turnRoom5 == false"
                class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button"
                  @click="goPayments();[habitacion1.datosContacto = false]; setRequirementsDataH1()"
                  :disabled="(email1.length != 0 && turnText) || isDisabledFormulario0">{{ $t('language.posadasCorporate.reservacionesRegistro.goPay') }}</button>
              </div>
              <div v-if="showRemainingRooms && turnRoom3 == false && turnRoom4 == false && turnRoom5 == false"
                class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button"
                  @click="goPayments();[habitacion1.datosContacto = false]; setRequirementsDataH2()"
                  :disabled="(email1.length != 0 && turnText) || isDisabledFormulario">{{ $t('language.posadasCorporate.reservacionesRegistro.goPay') }}</button>
              </div>
              <div v-if="turnRoom3 && turnRoom4 == false && turnRoom5 == false"
                class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button"
                  @click="goPayments();[habitacion2.datosContacto = false]; setRequirementsDataH3()"
                  :disabled="(email1.length != 0 && turnText) || isDisabledFormulario3">{{ $t('language.posadasCorporate.reservacionesRegistro.goPay') }}</button>
              </div>
              <div v-if="turnRoom4 && turnRoom5 == false"
                class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button"
                  @click="goPayments();[habitacion3.datosContacto = false]; setRequirementsDataH4()"
                  :disabled="(email1.length != 0 && turnText) || isDisabledFormulario4">{{ $t('language.posadasCorporate.reservacionesRegistro.goPay') }}</button>
              </div>
              <div v-if="turnRoom5" class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button"
                  @click="goPayments();[habitacion4.datosContacto = false]; setContactDataH5(); setRequirementsDataH5()"
                  :disabled="(email1.length != 0 && turnText) || isDisabledFormulario5">{{ $t('language.posadasCorporate.reservacionesRegistro.goPay') }}</button>
              </div>

            </div>

          </form>
        </div>
        <div class="col-12 col-lg-3">
          <div class="info">
            <sidebar-reserva :infoReserva="infoReserva" class="barRight"></sidebar-reserva>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel mobile Room Preferent -->
    <div class="section-full" v-bind:class="{ 'section-full--open': habitacion1.showRoomTypeMobile }">
      <div class="section-full__header">
        <button v-on:click="habitacion1.showRoomTypeMobile = false"><span class="icon-close"></span></button>
        <h4>{{ $t('language.posadasCorporate.reservacionesRegistro.roomPreferences') }}</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">
          <div class="typeRoom">
            <div class="d-block allRooms pb-2 mb-2">
              <label>
                <input type="checkbox" name="allTipo" id="allTipo" v-model="selectAll"
                  @click="habitacion1.roomPreferences = true" @change="handleType($event)">
                {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
              </label>
            </div>
            <div class="d-block p-b-10" v-for="typeRoomPreferent in habitacion1.typeRoomsPreferents"
              :key="typeRoomPreferent.id">
              <label>
                <input type="checkbox" v-model="habitacion1.selected" :value="typeRoomPreferent.id"
                  @change="handleTypeSelect($event, typeRoomPreferent.name)">
                {{ typeRoomPreferent.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarRoomtype()"
          :disabled="habitacion1.selected.length == 0">{{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</button>
        <button class="secondary-button"
          v-on:click="[selectAll = false, habitacion1.typePreferent = '']">{{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</button>
      </div>
    </div>

    <!-- Panel mobile Extra Preferent-->
    <div class="section-full" v-bind:class="{ 'section-full--open': habitacion1.showExtraTypeMobile }">
      <div class="section-full__header">
        <button v-on:click="habitacion1.showExtraTypeMobile = false"><span class="icon-close"></span></button>
        <h4>{{ $t('language.posadasCorporate.reservacionesRegistro.roomPreferences') }}</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">
          <div class="typeRoom">
            <div class="d-block allRooms pb-2 mb-2">
              <label>
                <input type="checkbox" name="allExtra" id="allExtra" v-model="selectAllExtra"
                  @click="habitacion1.extraPreferences = true" @change="handleTypeExtra($event)">
                {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences') }}
              </label>
            </div>
            <div class="d-block p-b-10" v-for="typeExtraPreferent in habitacion1.typeExtrasPreferents"
              :key="typeExtraPreferent.id">
              <label>
                <input type="checkbox" v-model="habitacion1.selectedExtra" :value="typeExtraPreferent.id"
                  @change="handleTypeSelectExtra($event, typeExtraPreferent.name)">
                {{ typeExtraPreferent.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarExtratype()"
          :disabled="habitacion1.selectedExtra.length == 0">{{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</button>
        <button class="secondary-button"
          v-on:click="[selectAllExtra = false, habitacion1.showExtraTypeMobile = false]">{{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</button>
      </div>
    </div>


    <!-- Panel mobile Room Preferent H2-->
    <div class="section-full" v-bind:class="{ 'section-full--open': habitacion2.showRoomTypeMobile }">
      <div class="section-full__header">
        <button v-on:click="habitacion2.showRoomTypeMobile = false"><span class="icon-close"></span></button>
        <h4>{{ $t('language.posadasCorporate.reservacionesRegistro.roomPreferences') }}</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">
          <div class="typeRoom">
            <div class="d-block allRooms pb-2 mb-2">
              <label>
                <input type="checkbox" name="allTipoH2" id="allTipoH2" v-model="selectAllH2"
                  @click="habitacion2.roomPreferences = true" @change="handleTypeH2($event)">
                {{ $t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion') }}
              </label>
            </div>
            <div class="d-block p-b-10" v-for="typeRoomPreferent in habitacion2.typeRoomsPreferents"
              :key="typeRoomPreferent.id">
              <label>
                <input type="checkbox" v-model="habitacion2.selected" :value="typeRoomPreferent.id"
                  @change="handleTypeSelectH2($event, typeRoomPreferent.name)">
                {{ typeRoomPreferent.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarRoomtypeH2()"
          :disabled="habitacion2.selected.length == 0">{{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</button>
        <button class="secondary-button"
          v-on:click="[selectAllH2 = false, habitacion2.roomPreferences = '']">{{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</button>
      </div>
    </div>

    <!-- Panel mobile Extra Preferent H2-->
    <div class="section-full" v-bind:class="{ 'section-full--open': habitacion2.showExtraTypeMobile }">
      <div class="section-full__header">
        <button v-on:click="habitacion2.showExtraTypeMobile = false"><span class="icon-close"></span></button>
        <h4>{{ $t('language.posadasCorporate.reservacionesRegistro.roomPreferences') }}</h4>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">
          <div class="typeRoom">
            <div class="d-block allRooms pb-2 mb-2">
              <label>
                <input type="checkbox" name="allExtraH2" id="allExtraH2" v-model="selectAllExtraH2"
                  @click="habitacion2.extraPreferences = true" @change="handleTypeExtraH2($event)">
                {{ $t('language.posadasCorporate.reservacionesRegistro.extraPreferences') }}
              </label>
            </div>
            <div class="d-block p-b-10" v-for="typeExtraPreferent in habitacion2.typeExtrasPreferents"
              :key="typeExtraPreferent.id">
              <label>
                <input type="checkbox" v-model="habitacion2.selectedExtra" :value="typeExtraPreferent.id"
                  @change="handleTypeSelectExtraH2($event, typeExtraPreferent.name)">
                {{ typeExtraPreferent.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarExtratypeH2()"
          :disabled="habitacion2.selectedExtra.length == 0">{{ $t('language.posadasCorporate.reservacionesRegistro.applyR') }}</button>
        <button class="secondary-button"
          v-on:click="[selectAllExtraH2 = false, habitacion2.typePreferentExtra = '']">{{ $t('language.posadasCorporate.reservacionesRegistro.realCancel') }}</button>
      </div>
    </div>

    <b-popover target="horaEntrada" triggers="hover focus" placement="bottom" customClass="PC-popover"
      :content="$t('language.posadasCorporate.reservacionesRegistro.tootlTip')"></b-popover>


    <b-popover target="horaSalida" triggers="hover focus" placement="bottom" customClass="PC-popover"
      :content="$t('language.posadasCorporate.reservacionesRegistro.tootlTip')"></b-popover>

    <Footer />

    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{
            $t('language.posadasCorporate.modales.expiredSession.title')
        }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

    <modal v-if="isModalConsiEspecial" @close="closeModalConsiEspecial" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ titleConsiEspecial }}</b>
      </template>
      <template slot="body">

        <div v-if="!mojito">
          <p class="Ta-left">
            {{ bodyConsiEspecial }}
          </p>
        </div>

        <div v-if="mojito">
          <p v-for="(conEsp, index) in bodyConsiEspecial" :key="index" class="Ta-left">
            {{ conEsp }}
          </p>
        </div>

      </template>
      <template slot="footer">
        <button type="button" class="primary-button" @click="closeModalConsiEspecial" aria-label="Close modal">
          {{ $t('language.posadasCorporate.reservacionesRegistro.continuar') }}
        </button>
      </template>
    </modal>

	<!-- TELEPHONE MODAL  -->
	<!-- INI KB48464  -->
	    <modal v-show="isModalTelephone" @close="closeModalTelephone" maxWidth="max-w-500 w-100">
	      <template slot="header">
		          <b class="caution mt-2 pt-3"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
				  {{$t('language.posadasCorporate.modalTelephone.alert')}}
          
        </b>
      </template>
      <template slot="body">
          {{$t('language.posadasCorporate.modalTelephone.mensaje')}}

      </template>
	  <template slot="footer">
	    <button type="button" align="center"
          @click="closeModalTelephone()" aria-label="Close modal">
          {{$t('language.posadasCorporate.modalTelephone.aceptar')}}
        </button>
      </template>
    </modal>
    <!-- FIN KB48464 -->
	<!-- TELEPHONE MODAL  -->


<!-- START KB49419 -->
   <!--  MODAL PREGUNTA SI QUIERES SER SOCIO -->
   <modal v-if="isModalQuestionSocio"  @close="closeQuestionSocio" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="caution mt-2 pt-3"> 
          {{ $t('language.posadasCorporate.PromoFiestaRewards.tituloModal') }}
        </b>
      </template>
      <template slot="body">
        <div class="wrapper">
          <div class="imagenSocio">
            <img src="../../../assets/img/logoFR.png">
          </div>
          <div class="textBox">
            <p>
              {{ $t('language.posadasCorporate.PromoFiestaRewards.textModalQuieroUnirme1') }}
            </p>
            <p>
              {{ $t('language.posadasCorporate.PromoFiestaRewards.textModalQuieroUnirme2') }}
            </p>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button"  @click="closeQuestionSocio" aria-label="Close modal">
          {{ $t('language.posadasCorporate.PromoFiestaRewards.backModal') }}
        </button>
        <button type="button" class="button btn-primary"  @click="openURLSocio" aria-label="Close modal">
          {{ $t('language.posadasCorporate.PromoFiestaRewards.OkModal') }}
        </button>
            
      </template>
    </modal>


    <!-- MODAL LLAMADO AL JS -->
    <modal v-show="isModalURLSocio"  @close="closeURLSocio2" maxWidth="max-w-700 w-60">
      <template slot="header">
        <b></b>
      </template>
      <template slot="body">
        <div class="fr-form-posadas"></div> 
      </template>


      <!--START KB51882 -->
      <template slot="footer">
          <button  v-show="banderaValidacionStorage" type="button" class="button btn-primary"  @click="closeURLSocio2" aria-label="Close modal">
             {{ $t('language.posadasCorporate.PromoFiestaRewards.textModalVerifyContniuar') }}
          </button>
      </template>
     
      <!--END KB51882 -->
    </modal>  


    <!-- MODAL validacion correo -->
    <modal v-show="isModalPass"  @close="openisModalPass" maxWidth="max-w-700 w-60">
      <template slot="header">
        <b></b>
      </template>
      <template slot="body">
        <p>
            {{ $t('language.posadasCorporate.PromoFiestaRewards.textModalVerify') }}
        </p>
      </template>
     <template slot="footer">
          <button type="button" class="button btn-primary"  @click="openisModalPass" aria-label="Close modal">
            {{ $t('language.posadasCorporate.PromoFiestaRewards.textModalVerifyContniuar') }}
          </button>
      </template>
    </modal>  

 <!-- END KB49419-->

  </div>
</template>

<script>
import * as GlobalServices from '../../../utils/GlobalServices';
import * as GlobalFunctions from '../../../utils/GlobalFunctions';
import Header from '../../generales/Header.vue';
import SidebarReserva from '../SidebarReserva.vue';
import SidebarReservaTop from '../SidebarReservaTop.vue';
import Footer from '../../generales/Footer.vue';
import axios from 'axios';
import SecureLS from 'secure-ls';
import i18n from '../../../plugins/i18n';
import Modal from '../../addons/Modal.vue'
import Loader from "../../loader/Loader";
//KB47296 Start
import { validatePhoneNumber } from "../../../utils/GlobalFunctions";
import LadasInternacionales from '../../../utils/LadasInternacionales.json';
//KB51716

//KB47296 End
import {
  required,
  email,
  sameAs,
} from "vuelidate/lib/validators";
export default {
  name: 'ReservacionesRegistro',
  components: {
    Header,
    SidebarReserva,
    SidebarReservaTop,
    Footer,
    Modal,
    Loader
  },
  data: () => {
    return {
      //START KB54578
      codePaisNew: '',
      codePaisNew2: '',
      numeroTelNew: '',
      boleanTelefono: false,
      banSelectedTelefono: false,
      findingTelefono: '',
      jsonPaises: [],
      //END KB54578
      //START KB51882
      banderaValidacionStorage: false,
      myInterval: "",
      //END KB51882
      //START KB49419
      banderaFiesaRe: false,
      imgSocio: "../../../assets/img/logoFR.png",
      isModalQuestionSocio: false,
      isModalURLSocio: false,
      isModalPass: false,
      //END KB49419
      telInput: 0,
      banLoaderPerfiles: true,
      banSelectedPais: false,
      isUserGeneric: false,
      officeNumber: "",
      homeNumber: "",
      cellNumber: "",
      banderita: false,
      totalChambres: 1,
      banSendProformGranted2: false,
      descriptionMS: "",
      totalQuantityMS: "",
      mojito: false,
      titleConsiEspecial: '',
      isModalConsiEspecial: false,
      // INI KB48464
	  isModalTelephone: false,
	  flagIsModalTelephone: true,
	  // FIN KB48464
      bodyConsiEspecial: '',
      banLoaderFR: false,
      srcImageFRCard: 0,
      infoFR: null,
      banMemFR: false,
      enableRewards: false,
      paragraph1: "",
      paragraph2: "",
      isCuba: false,
      listRequeOpcionales: [],
      listRequeOpcionalesSeleccionados: [],
      banReqOpcionales: false,
      emailIsRepeated: false,
      emailProfile: '',
      guestProfileIdValidator: "",
      middleNameForService2: '',
      middleNameForService3: '',
      middleNameForService4: '',
      middleNameForService5: '',
      ls: new SecureLS({ encodingType: 'aes' }),
      getApreciareOff: false,
      getRewardsOff: false,
      hideRequirements: false,
      stateCodeForReservationRequest: '',
      countryCodeForReservationRequest: '',
      titleNumberForReservationRequest: 0,
      mainGuestProfileId: '',
      nameForService: '',
      middleNameForService: '',
      saveNewProfileH1: false,
      saveNewProfileH2: false,
      saveNewProfileH3: false,
      saveNewProfileH4: false,
      saveNewProfileH5: false,
      sendProform: false,
      company1Name: '',
      company1LastName: '',
      company1SecondLastName: '',
      turnTextRoom2: false,
      turnTextRoom3: false,
      turnTextRoom4: false,
      turnTextRoom5: false,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      hola: 'PA',
      email1: '',
      turnText: false,
      hello: 'PO',
      isExpiredModalVisible: false,
      banSuplement: false,
      banSendProformGranted: false,
      dataRequeriment: null,
      listRequeriment: null,
      listSuplement: null,
      infoReserva: null,
      turnRoom2: false,
      turnRoom3: false,
      turnRoom4: false,
      turnRoom5: false,
      guestProfileId: '',
      pickedDireccion: '',
      privacyLink: '',
      pickedTelelefonoCelular: '',
      pickedPhone: '',
      pickedTelelefonoOffice: '',
      selectedCountry: '',
      finding: '',
      localityF: '',
      findingCountry: '',
      zipCode: '',
      street: '',
      simpleName: '',
      fatherSurname: '',
      motherSurname: '',
      agentNumber: '',
      rewardsNumber: '',
      //KB49419
      rewardsCode: '',
      apreciation: '',
      costCenter: '',
      nowsTime: false,
      fiestaRewardsNumber: '',
      showMainRoom: false,
      selectedProfile: '',
      selectedProfile2: '',
      selectedProfile3: '',
      selectedProfile4: '',
      selectedProfile5: '',

      perfiles: [],
      token: '',
      language: '',
      nombreChambres: [],
      device: 'desktop',
      habitacion1: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        datosAcompanante: true,
        datosProforma: true,
        datosRequerimientos: true,
        // buscador
        buscador: false,
        search: '',
        perfiles: [
        ],
        perfilesLista: '',
        // Titulo
        titulo: false,
        tituloDado: '',
        titulos: [
          { 'nombre': 'Sr.', 'number': 2 },
          { 'nombre': 'Sra.', 'number': 3 },
          { 'nombre': 'Srita.', 'number': 4 },
        ],
        // Nombre
        nombres: 'PEDRo', //no cambiar este valor
        apellidoP: 'ZAMBRANo', //no cambiar este valor
        apellidoM: 'ZAMBRANo', //no cambiar este valor
        // Numeros
        numEmp: '',
        numFiesta: '',
        numApreciare: '',
        numCentro: '',
        numTelefonico: '',
        // tipos de telefono
        pickedTelelefono: "",
        // tipos de direccion
        pickedDireccion: "",
        // tipos de Propocitos
        pickedPropositos: "",
        // tipos de Piso
        pickedPiso: "",
        // Área de fumar
        pickedFumar: "",
        // Contacto
        mailContacto: '',
        mailContactoConfirmacion: '',
        //paises
        pais: false,
        paisSeleccionado: '',
        paises2: [],
        paises: [
        ],
        //estados
        estado: false,
        estadoSeleccionado: '',
        estados2: [],
        estados: [
        ],
        //hora entrada
        horaIn: false,
        horaInSeleccionado: '',
        horasIn: [
          { 'nombre': '00:00' },
          { 'nombre': '01:00' },
          { 'nombre': '02:00' },
          { 'nombre': '03:00' },
          { 'nombre': '04:00' },
          { 'nombre': '05:00' },
          { 'nombre': '06:00' },
          { 'nombre': '07:00' },
          { 'nombre': '08:00' },
          { 'nombre': '09:00' },
          { 'nombre': '10:00' },
          { 'nombre': '11:00' },
          { 'nombre': '12:00' },
          { 'nombre': '13:00' },
          { 'nombre': '14:00' },
          { 'nombre': '15:00' },
          { 'nombre': '16:00' },
          { 'nombre': '17:00' },
          { 'nombre': '18:00' },
          { 'nombre': '19:00' },
          { 'nombre': '20:00' },
          { 'nombre': '21:00' },
          { 'nombre': '22:00' },
          { 'nombre': '23:00' },
        ],
        //hora de salida
        horaOut: false,
        horaOutSeleccionado: '',
        horasOut: [
          { 'nombre': '00:00' },
          { 'nombre': '01:00' },
          { 'nombre': '02:00' },
          { 'nombre': '03:00' },
          { 'nombre': '04:00' },
          { 'nombre': '05:00' },
          { 'nombre': '06:00' },
          { 'nombre': '07:00' },
          { 'nombre': '08:00' },
          { 'nombre': '09:00' },
          { 'nombre': '10:00' },
          { 'nombre': '11:00' },
          { 'nombre': '12:00' },
          { 'nombre': '13:00' },
          { 'nombre': '14:00' },
          { 'nombre': '15:00' },
          { 'nombre': '16:00' },
          { 'nombre': '17:00' },
          { 'nombre': '18:00' },
          { 'nombre': '19:00' },
          { 'nombre': '20:00' },
          { 'nombre': '21:00' },
          { 'nombre': '22:00' },
          { 'nombre': '23:00' },
        ],
        // Requerimientos
        //tipo de preferencia
        typePreferent: '',
        roomPreferences: true,
        typeRoomsPreferents: [
          { 'id': '1', 'name': 'Balcón' },
          { 'id': '2', 'name': 'Cuartos adjuntos' },
          { 'id': '3', 'name': 'Cuartos conectados' },
          { 'id': '4', 'name': 'Cama extra' },
          { 'id': '5', 'name': 'Cerca del elevador' },
          { 'id': '6', 'name': 'Cuarto silencioso' },
          { 'id': '7', 'name': 'Lejos del elevador' },
        ],
        selected: [],
        showRoomTypeMobile: false,
        //tipo de preferencia extra
        typePreferentExtra: '',
        extraPreferences: true,
        typeExtrasPreferents: [
          { 'id': '1', 'name': 'Aniversario de boda' },
          { 'id': '2', 'name': 'Lunamieleros' },
          { 'id': '3', 'name': 'Salida tardía' },
        ],
        selectedExtra: [],
        showExtraTypeMobile: false,
      },
      habitacion2: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        datosRequerimientos: true,
        // buscador
        buscador: false,
        search: '',
        perfiles: [
        ],
        // Titulo
        titulo: false,
        tituloDado: '',
        titulos: [
          { 'nombre': 'Sr.' },
          { 'nombre': 'Sra.' },
          { 'nombre': 'Srita.' },
        ],
        // Nombre
        nombres: '',
        apellidoP: '',
        apellidoM: '',
        // tipos de Piso
        pickedPiso: "",
        // Área de fumar
        pickedFumar: "",
        // Contacto
        mailContacto: '',
        mailContactoConfirmacion: '',
        // Requerimientos
        //tipo de preferencia
        typePreferent: '',
        roomPreferences: true,
        typeRoomsPreferents: [
          { 'id': '1', 'name': 'Balcón' },
          { 'id': '2', 'name': 'Cuartos adjuntos' },
          { 'id': '3', 'name': 'Cuartos conectados' },
          { 'id': '4', 'name': 'Cama extra' },
          { 'id': '5', 'name': 'Cerca del elevador' },
          { 'id': '6', 'name': 'Cuarto silencioso' },
          { 'id': '7', 'name': 'Lejos del elevador' },
        ],
        selected: [],
        showRoomTypeMobile: false,
        //tipo de preferencia extra
        typePreferentExtra: '',
        extraPreferences: true,
        typeExtrasPreferents: [
          { 'id': '1', 'name': 'Aniversario de boda' },
          { 'id': '2', 'name': 'Lunamieleros' },
          { 'id': '3', 'name': 'Salida tardía' },
        ],
        selectedExtra: [],
        showExtraTypeMobile: false,
      },
      habitacion5: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        datosRequerimientos: true,
        // buscador
        buscador: false,
        search: '',
        perfiles: [
        ],
        // Titulo
        titulo: false,
        tituloDado: '',
        titulos: [
          { 'nombre': 'Sr.' },
          { 'nombre': 'Sra.' },
          { 'nombre': 'Srita.' },
        ],
        // Nombre
        nombres: '',
        apellidoP: '',
        apellidoM: '',
        // tipos de Piso
        pickedPiso: "",
        // Área de fumar
        pickedFumar: "",
        // Contacto
        mailContacto: '',
        mailContactoConfirmacion: '',
        // Requerimientos
        //tipo de preferencia
        typePreferent: '',
        roomPreferences: true,
        typeRoomsPreferents: [
          { 'id': '1', 'name': 'Balcón' },
          { 'id': '2', 'name': 'Cuartos adjuntos' },
          { 'id': '3', 'name': 'Cuartos conectados' },
          { 'id': '4', 'name': 'Cama extra' },
          { 'id': '5', 'name': 'Cerca del elevador' },
          { 'id': '6', 'name': 'Cuarto silencioso' },
          { 'id': '7', 'name': 'Lejos del elevador' },
        ],
        selected: [],
        showRoomTypeMobile: false,
        //tipo de preferencia extra
        typePreferentExtra: '',
        extraPreferences: true,
        typeExtrasPreferents: [
          { 'id': '1', 'name': 'Aniversario de boda' },
          { 'id': '2', 'name': 'Lunamieleros' },
          { 'id': '3', 'name': 'Salida tardía' },
        ],
        selectedExtra: [],
        showExtraTypeMobile: false,
      },
      habitacion4: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        datosRequerimientos: true,
        // buscador
        buscador: false,
        search: '',
        perfiles: [
        ],
        // Titulo
        titulo: false,
        tituloDado: '',
        titulos: [
          { 'nombre': 'Sr.' },
          { 'nombre': 'Sra.' },
          { 'nombre': 'Srita.' },
        ],
        // Nombre
        nombres: '',
        apellidoP: '',
        apellidoM: '',
        // tipos de Piso
        pickedPiso: "",
        // Área de fumar
        pickedFumar: "",
        // Contacto
        mailContacto: '',
        mailContactoConfirmacion: '',
        // Requerimientos
        //tipo de preferencia
        typePreferent: '',
        roomPreferences: true,
        typeRoomsPreferents: [
          { 'id': '1', 'name': 'Balcón' },
          { 'id': '2', 'name': 'Cuartos adjuntos' },
          { 'id': '3', 'name': 'Cuartos conectados' },
          { 'id': '4', 'name': 'Cama extra' },
          { 'id': '5', 'name': 'Cerca del elevador' },
          { 'id': '6', 'name': 'Cuarto silencioso' },
          { 'id': '7', 'name': 'Lejos del elevador' },
        ],
        selected: [],
        showRoomTypeMobile: false,
        //tipo de preferencia extra
        typePreferentExtra: '',
        extraPreferences: true,
        typeExtrasPreferents: [
          { 'id': '1', 'name': 'Aniversario de boda' },
          { 'id': '2', 'name': 'Lunamieleros' },
          { 'id': '3', 'name': 'Salida tardía' },
        ],
        selectedExtra: [],
        showExtraTypeMobile: false,
      },
      habitacion3: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        datosRequerimientos: true,
        // buscador
        buscador: false,
        search: '',
        perfiles: [
        ],
        // Titulo
        titulo: false,
        tituloDado: '',
        titulos: [
          { 'nombre': 'Sr.' },
          { 'nombre': 'Sra.' },
          { 'nombre': 'Srita.' },
        ],
        // Nombre
        nombres: '',
        apellidoP: '',
        apellidoM: '',
        // tipos de Piso
        pickedPiso: "",
        // Área de fumar
        pickedFumar: "",
        // Contacto
        mailContacto: '',
        mailContactoConfirmacion: '',
        // Requerimientos
        //tipo de preferencia
        typePreferent: '',
        roomPreferences: true,
        typeRoomsPreferents: [
          { 'id': '1', 'name': 'Balcón' },
          { 'id': '2', 'name': 'Cuartos adjuntos' },
          { 'id': '3', 'name': 'Cuartos conectados' },
          { 'id': '4', 'name': 'Cama extra' },
          { 'id': '5', 'name': 'Cerca del elevador' },
          { 'id': '6', 'name': 'Cuarto silencioso' },
          { 'id': '7', 'name': 'Lejos del elevador' },
        ],
        selected: [],
        showRoomTypeMobile: false,
        //tipo de preferencia extra
        typePreferentExtra: '',
        extraPreferences: true,
        typeExtrasPreferents: [
          { 'id': '1', 'name': 'Aniversario de boda' },
          { 'id': '2', 'name': 'Lunamieleros' },
          { 'id': '3', 'name': 'Salida tardía' },
        ],
        selectedExtra: [],
        showExtraTypeMobile: false,
      },
      formulario1: {
        huesped: '',
        contacto: '',
        acompanante: '',
        proforma: '',
        requerimientos: '',
      },
      formulario2: {
        personales: '',
        contacto: '',
      },
      formulario3: {
        personales: '',
        contacto: '',
      },
      formulario4: {
        personales: '',
        contacto: '',
      },
      formulario5: {
        personales: '',
        contacto: '',
      },
    }
  },
  validations: {
    habitacion1: {
      mailContacto: {
        required,
        email,
      },
      mailContactoConfirmacion: {
        required,
        email,
      },
    }
  },
  mounted() {
    this.ls.set('supleCondi', null)
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });

    var lang = this.ls.get('Language').data;
    var idiomaForm = "";

    if(lang == 'es'){
      idiomaForm= "mx"
    }else{
      idiomaForm= "us"
    }

    // Start 49419
    jQuery(document).ready(async function() {
      await jQuery('.fr-form-posadas').form_fistarewards({
        language: idiomaForm,
        callcenter: true,
        canal: "CORPORATE"
      });
      jQuery('#attributes-country').css('padding', '5px');
    });
    // End 49419
  },
  destroyed() {
    this.ls.remove('requeriment');
  },
  created() {
    this.isUserGeneric = this.ls.get('isUserGeneric').data;
    var resetMajor = this.ls.get('updateCostDetail').data
    let disconfig = this.ls.get('DISCONFIG');
    this.banSendProformGranted = disconfig.data.sendProformGranted;
    resetMajor.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
    resetMajor.hotel.negotiatedRatesDetailPrice.extraTaxes = 0
    this.ls.set('updateCostDetail', { data: resetMajor })

    this.ls.set('changeTitleMod', false)
    this.totalChambres = this.ls.get('updateCostDetail').data.habitacion.totalRooms
    if (this.ls.get('unableApreciare').data == true) {
      this.getApreciareOff = true
    } else {
      this.getApreciareOff = false
    }
    this.requerimientosSuplement();
    this.initializing();
    this.sendProform = false
  },
  watch: {
    persistRegistryData() {

    },
    pickedTelelefonoCelular() {
      //KB47296 Start
      switch (this.pickedTelelefonoCelular) {
        case "MOB":
          if (this.cellNumber !== "") {
            this.habitacion1.numTelefonico = this.cellNumber
          }
          break;
        case "HOM":
          if (this.homeNumber !== "") {
            this.habitacion1.numTelefonico = this.homeNumber
          }
          break;
        case "BUS":
          if (this.officeNumber !== "") {
            this.habitacion1.numTelefonico = this.officeNumber
          }
          break;
        default:
          break;
      }

      this.isDisabledContacto;

      const auxPhoneNumber = this.habitacion1.nationalNumber ? this.habitacion1.nationalNumber : this.habitacion1.numTelefonico;

      if(this.habitacion1.areaCode && auxPhoneNumber){
        this.habitacion1.numTelefonico = validatePhoneNumber(this.habitacion1.areaCode, auxPhoneNumber, this.pickedTelelefonoCelular);
      }else{
        this.habitacion1.areaCode = "+52";
        this.habitacion1.numTelefonico = validatePhoneNumber(this.habitacion1.areaCode, auxPhoneNumber, this.pickedTelelefonoCelular);
      }
      //KB47296 End

    },
    sendProform() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let sendProformH1 = {};
      sendProformH1.sendProformH1 = this.sendProform;
      ls.set('sendProformH1', sendProformH1);
    },
    rewardsNumber() {
      this.enableRewards = false;
      this.banMemFR = false;
      this.banLoaderFR = false;
    },
    selectedCountry() {
      if (this.selectedCountry == '') {
        this.habitacion1.estadoSeleccionado = ''
      }
    },
    findingCountry() {
      var codeCountry = ''
      var ls = new SecureLS({ encodingType: 'aes' });
      var a = ''
      a = ls.get('Token')
      this.token = a.data.substr(1);
      this.language = ls.get('Language');
      if (this.findingCountry != '') {
        for (var x = 0; x < this.habitacion1.paises.length; x++) {
          if (this.findingCountry == this.habitacion1.paises[x].nombre) {
            codeCountry = this.habitacion1.paises[x].countryCode
          }
        }
        // Consultar estados
        this.habitacion1.estados = []
        axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY + `/${codeCountry}/` + process.env.VUE_APP_STATE,
          {
            withCredentials: true,
            credentials: 'include',
            headers: {
              'Authorization': 'Bearer ' + this.token,
              'Accept-Language': this.language.data,
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            var resObject = JSON.parse(JSON.stringify(res));
            if (resObject.status == 200 || resObject.status == 201) {
              this.habitacion1.estados = resObject.data.response
              this.habitacion1.estados2 = resObject.data.response
            }
          })
          .catch(error => {
            // Error server
            if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
              this.$router.push({ name: "Error" });
            }
            // Error server 
            let errorObject = JSON.parse(JSON.stringify(error));
            if (errorObject.message == 'Request failed with status code 401') {
              this.clearLocalStorage()
            } else {
            }
          })
        // Fin de consultar estados
      }
    },

    selectedProfile2() {
      for (var i = 0; i < this.habitacion2.perfiles.length; i++) {
        if (this.selectedProfile2 == this.habitacion2.perfiles[i].nombre) {
          this.habitacion2.nombres = this.habitacion2.perfiles[i].simpleName
          this.habitacion2.apellidoP = this.habitacion2.perfiles[i].fatherSurname
          this.habitacion2.apellidoM = this.habitacion2.perfiles[i].motherSurname
          this.habitacion2.mailContacto = this.habitacion2.perfiles[i].mailContacto
          this.middleNameForService2 = this.habitacion2.perfiles[i].middleNameForService


        }
      }

      if (this.selectedProfile2 == '') {
        this.habitacion2.nombres = ''
        this.habitacion2.apellidoP = ''
        this.habitacion2.apellidoM = ''
        this.habitacion2.mailContacto = ''

      }

    },

    selectedProfile3() {
      for (var i = 0; i < this.habitacion3.perfiles.length; i++) {
        if (this.selectedProfile3 == this.habitacion3.perfiles[i].nombre) {
          this.habitacion3.nombres = this.habitacion3.perfiles[i].simpleName
          this.habitacion3.apellidoP = this.habitacion3.perfiles[i].fatherSurname
          this.habitacion3.apellidoM = this.habitacion3.perfiles[i].motherSurname
          this.habitacion3.mailContacto = this.habitacion3.perfiles[i].mailContacto
          this.middleNameForService3 = this.habitacion3.perfiles[i].middleNameForService


        }
      }

      if (this.selectedProfile3 == '') {
        this.habitacion3.nombres = ''
        this.habitacion3.apellidoP = ''
        this.habitacion3.apellidoM = ''
        this.habitacion3.mailContacto = ''

      }

    },


    selectedProfile4() {
      for (var i = 0; i < this.habitacion4.perfiles.length; i++) {
        if (this.selectedProfile4 == this.habitacion4.perfiles[i].nombre) {
          this.habitacion4.nombres = this.habitacion4.perfiles[i].simpleName
          this.habitacion4.apellidoP = this.habitacion4.perfiles[i].fatherSurname
          this.habitacion4.apellidoM = this.habitacion4.perfiles[i].motherSurname
          this.habitacion4.mailContacto = this.habitacion4.perfiles[i].mailContacto
          this.middleNameForService4 = this.habitacion4.perfiles[i].middleNameForService


        }
      }

      if (this.selectedProfile4 == '') {
        this.habitacion4.nombres = ''
        this.habitacion4.apellidoP = ''
        this.habitacion4.apellidoM = ''
        this.habitacion4.mailContacto = ''

      }

    },

    selectedProfile5() {
      for (var i = 0; i < this.habitacion5.perfiles.length; i++) {
        if (this.selectedProfile5 == this.habitacion5.perfiles[i].nombre) {
          this.habitacion5.nombres = this.habitacion5.perfiles[i].simpleName
          this.habitacion5.apellidoP = this.habitacion5.perfiles[i].fatherSurname
          this.habitacion5.apellidoM = this.habitacion5.perfiles[i].motherSurname
          this.habitacion5.mailContacto = this.habitacion5.perfiles[i].mailContacto
          this.middleNameForService5 = this.habitacion5.perfiles[i].middleNameForService


        }
      }

      if (this.selectedProfile5 == '') {
        this.habitacion5.nombres = ''
        this.habitacion5.apellidoP = ''
        this.habitacion5.apellidoM = ''
        this.habitacion5.mailContacto = ''

      }

    },


    selectedProfile() {
      this.banderita = false;
      var ls = new SecureLS({ encodingType: 'aes' });
      var a = ''
      a = ls.get('Token')
      this.token = a.data.substr(1);
      this.language = ls.get('Language');
      for (var i = 0; i < this.habitacion1.perfiles.length; i++) {
        if (this.selectedProfile == this.habitacion1.perfiles[i].guestProfileId) {
          this.habitacion1.mailContacto = this.habitacion1.perfiles[i].mailContacto
          this.habitacion1.mailContactoConfirmacion = this.habitacion1.perfiles[i].mailContactoConfirmacion
          this.mainGuestProfileId = this.habitacion1.perfiles[i].guestProfileId
          this.nameForService = this.habitacion1.perfiles[i].mainNameForService
          this.middleNameForService = this.habitacion1.perfiles[i].middleNameForService


          var stateCode2 = this.habitacion1.perfiles[i].state
          for (var findCountry = 0; findCountry < this.habitacion1.paises2.length; findCountry++) {
            if (this.habitacion1.paises2[findCountry].countryCode == this.habitacion1.perfiles[i].country) {
              this.habitacion1.paisSeleccionado = this.habitacion1.paises2[findCountry].nombre
              this.cambiaPais(this.habitacion1.paisSeleccionado)
              //START KB56697
              var numeroTelefonoDefault = {
                        "name": "MEXICO (celular)",
                        "lada": "521",
                        "fullname": "MEXICO (celular) +521"
                }
              this.cambiaTelefono(numeroTelefonoDefault)
              //END KB56697
              axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY + `/${this.habitacion1.perfiles[i].country}/` + process.env.VUE_APP_STATE,
                {
                  withCredentials: true,
                  credentials: 'include',
                  headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Accept-Language': this.language.data,
                    'Content-Type': 'application/json'
                  }
                })
                .then(res => {
                  var resObject = JSON.parse(JSON.stringify(res));
                  if (resObject.status == 200 || resObject.status == 201) {

                    this.habitacion1.estados2 = resObject.data.response

                    for (var findState = 0; findState < this.habitacion1.estados2.length; findState++) {
                      if (this.habitacion1.estados2[findState].stateCode == stateCode2) {
                        this.habitacion1.estadoSeleccionado = this.habitacion1.estados2[findState].stateName
                      }
                    }
                  } else {
                  }
                })
                .catch(error => {
                  // Error server
                  if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
                    this.$router.push({ name: "Error" });
                  }
                  // Error server 
                  let errorObject = JSON.parse(JSON.stringify(error));
                  if (errorObject.message == 'Request failed with status code 401') {
                    this.clearLocalStorage()
                  }
                })

            }
          }
          this.street = this.habitacion1.perfiles[i].streetNameWithNumber.toUpperCase(),
            this.localityF = this.habitacion1.perfiles[i].locality.toUpperCase(),
            this.zipCode = this.habitacion1.perfiles[i].zipCode
          //START KB56697
          this.numeroTelNew =  this.habitacion1.perfiles[i].numeroTelNew
          //console.log("habitacion1.perfiles" + JSON.stringify(this.habitacion1.perfiles[i]));
          //END KB56697
          if (this.habitacion1.perfiles[i].addressType == "MOB" || this.habitacion1.perfiles[i].addressType == "HOM") {

            this.pickedDireccion = 'MOB'
          }
          if (this.habitacion1.perfiles[i].addressType == "BUS") {

            this.pickedDireccion = 'MOB'
          }
          this.guestProfileId = this.habitacion1.perfiles[i].guestProfileId
          this.fiestaRewardsNumber = this.habitacion1.perfiles[i].fiestaRewardsNumber
          this.simpleName = this.habitacion1.perfiles[i].simpleName
          this.fatherSurname = this.habitacion1.perfiles[i].fatherSurname
          this.motherSurname = this.habitacion1.perfiles[i].motherSurname
          this.agentNumber = this.habitacion1.perfiles[i].agentNumber
          this.rewardsNumber = this.habitacion1.perfiles[i].rewardsNumber
          if (this.rewardsNumber.length >= 7) {
            this.consultFiestaRewards();
          }
          this.apreciation = this.habitacion1.perfiles[i].apreciation
          this.costCenter = this.habitacion1.perfiles[i].costCenter
        }
      }
      if (this.selectedProfile != '') {
        this.callGuestDetail(this.guestProfileId, this.fiestaRewardsNumber)
      } else {
        this.zipCode = ''
        this.localityF = ''
        this.street = ''
        this.simpleName = ''
        this.fatherSurname = ''
        this.motherSurname = ''
        this.agentNumber = ''
        this.rewardsNumber = ''
        this.apreciation = ''
        this.costCenter = ''
        this.habitacion1.mailContacto = ''
      }
    }
  },
  methods: {
     handleInput(i) {
      // Filtrar el carácter '|' del valor del input
      console.log("value i from handleInput"+i);
      this.i = this.i.replace(/\|/g, '');
    
       alert('El carácter "|" no está permitido al pegar texto.');
   //   this.filteredPolilticas();
    },
      handlePaste(event ) {
       const lang=this.ls.get('Language').data;
       console.log("value for this.language"+lang);
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (pastedText.includes('|')) {           
        event.preventDefault();
         if(lang == 'es'){
           alert('El carácter "|" no está permitido al pegar texto.');           
        }else{
           alert('The "|" character is not allowed when pasting text');
        }
          
      }
     
  },
   
      resetSelectedPais() {
      this.banSelectedPais = false;
      this.habitacion1.estadoSeleccionado = '';
    },
      resetSelectedTelefono() {
      this.banSelectedTelefono = false;
      //this.habitacion1.estadoSeleccionado = '';
    },
    validateSuplement(originalSupplementCode) {
      if (!this.persistRegistryData && this.$store.getters.getOptionalSupplements.optionalSupplementsObject != null) {
        const persistedOptSu = this.$store.getters.getOptionalSupplements.optionalSupplementsObject.filter((optSup) => {
          return optSup.reqOpcional.supplementCode == originalSupplementCode
        })
        return persistedOptSu.length != 0 ? true : false
      } else {
        return false
      }
    },
    filteredListTitulos() {
      return this.habitacion1.titulos.filter(titulo => {
        return titulo.nombre.toLowerCase().includes(this.habitacion1.tituloDado.toLowerCase())
      })
    },
    filteredListPaises() {
      return this.habitacion1.paises.filter(pais => {
        this.selectedCountry = this.habitacion1.paisSeleccionado
        return pais.nombre.toLowerCase().includes(this.habitacion1.paisSeleccionado.toLowerCase())
      })
    },
    filteredListTelefono() {
      return this.jsonPaises.filter(pais => {
        //this.selectedCountry = this.habitacion1.paisSeleccionado
        return pais.name.toLowerCase().includes(this.codePaisNew.toLowerCase())
    })
    },
    filteredListEstado() {
      return this.habitacion1.estados.filter(estado => {
        return estado.stateName.toLowerCase().includes(this.habitacion1.estadoSeleccionado.toLowerCase())
      })
    },
    filteredListHorasIn() {
      return this.habitacion1.horasIn.filter(horaIn => {
        return horaIn.nombre.toLowerCase().includes(this.habitacion1.horaInSeleccionado.toLowerCase())
      })
    },
    filteredListHorasOut() {
      return this.habitacion1.horasOut.filter(horaOut => {
        return horaOut.nombre.toLowerCase().includes(this.habitacion1.horaOutSeleccionado.toLowerCase())
      })
    },
    // Habitacion 2
    filteredListH2() {
      return this.habitacion1.perfilesLista = this.habitacion2.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.habitacion2.search.toLowerCase())
      })
    },
    filteredListH3() {
      return this.habitacion1.perfilesLista = this.habitacion3.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.habitacion3.search.toLowerCase())
      })
    },
    filteredListH4() {
      return this.habitacion1.perfilesLista = this.habitacion4.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.habitacion4.search.toLowerCase())
      })
    },
    filteredListH5() {
      return this.habitacion1.perfilesLista = this.habitacion5.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.habitacion5.search.toLowerCase())
      })
    },
    filteredListTitulosH2() {
      return this.habitacion2.titulos.filter(titulo => {
        return titulo.nombre.toLowerCase().includes(this.habitacion2.tituloDado.toLowerCase())
      })
    },
    filteredListTitulosH3() {
      return this.habitacion3.titulos.filter(titulo => {
        return titulo.nombre.toLowerCase().includes(this.habitacion3.tituloDado.toLowerCase())
      })
    },
    filteredListTitulosH4() {
      return this.habitacion4.titulos.filter(titulo => {
        return titulo.nombre.toLowerCase().includes(this.habitacion4.tituloDado.toLowerCase())
      })
    },
    filteredListTitulosH5() {
      return this.habitacion5.titulos.filter(titulo => {
        return titulo.nombre.toLowerCase().includes(this.habitacion5.tituloDado.toLowerCase())
      })
    },
    cleanGuestProfileDetail() {
      this.banderita = true;
      this.ls.remove('GuestProfileDetail');
    },
    filteredList() {
      return this.habitacion1.perfilesLista = this.habitacion1.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.habitacion1.search.toLowerCase())
      })
    },
    consultFiestaRewards() {
      this.enableRewards = false;
      this.banMemFR = false;
      var longRewards = this.rewardsNumber.toUpperCase() + '';
      console.log("membernumber", localStorage.getItem('membernumber'));
      console.log("availablePoints", localStorage.getItem('availablePoints'));
      console.log("Tier", localStorage.getItem('Tier'));

      //START KB49419  - VALIDA SI SOLO ENTRA UNA VEZ
      if(this.banderaFiesaRe == false){
        if (longRewards.length >= 7) {
        this.banLoaderFR = true;
        var a = "";
        a = this.ls.get("Token");
        var token = a.data.substr(1);
        const lang = this.ls.get('Language').data;
        axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_REWARDSF + `${this.rewardsNumber}`,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
              "Accept-language": this.ls.get("Language").data
            }
          }
        )
          .then(response => {
            if (response.data.response.fiestaRewardsCode === 'FR' || response.data.response.fiestaRewardsCode === 'FRC') {
              this.srcImageFRCard = (lang === 'es' ? 1 : 2);
            }
            if (response.data.response.fiestaRewardsCode === 'VRO') {
              this.srcImageFRCard = (lang === 'es' ? 3 : 4);
            }
            if (response.data.response.fiestaRewardsCode === 'VRP') {
              this.srcImageFRCard = (lang === 'es' ? 5 : 6);
            }
            if (response.data.response.fiestaRewardsCode === 'FRB') {
              this.srcImageFRCard = (lang === 'es' ? 7 : 8);
            }
            if (response.data.response.fiestaRewardsCode === 'FRO') {
              this.srcImageFRCard = (lang === 'es' ? 9 : 10);
            }
            this.infoFR = response.data.response;
            this.rewardsCode = response.data.response.fiestaRewardsCode;

            this.enableRewards = false;
            this.banLoaderFR = false;
            setTimeout(() => {
              this.banMemFR = true;
            }, 10);
          })
    
          .catch(error => {
            // Error server
            if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
              this.$router.push({ name: "Error" });
            }
            // Error server 
            this.enableRewards = true;
            this.banLoaderFR = false;
            if (error.response.status == 401 || error.response.status == 403 || error.response.status == 500 || error.response.status == 501 || error.response.status == 502 || error.response.status == 504) {
              this.$router.push({ name: "Error" });
            }
          });
      }
      }
      else{
      //Metodo Hardcodeado
      this.banderaFiesaRe = false;
      const lang = this.ls.get('Language').data;

      var fiestaRewardsCodeCon = localStorage.getItem('Tier').toUpperCase();
      var fiestaRewardsCode1 = '';

      switch (fiestaRewardsCodeCon) {
        case 'AZUL':
          fiestaRewardsCode1 = 'FR';
          break;
        case 'AZUL-SANTANDER':
          fiestaRewardsCode1 = 'FR';
          break;
        case 'CLASICO':
          fiestaRewardsCode1 = 'FR';
          break;
        case 'ORO':
          fiestaRewardsCode1 = 'VRO';
          break;
        case 'ORO-SANTANDER':
          fiestaRewardsCode1 = 'VRO';
          break;
        case 'PLATINO':
          fiestaRewardsCode1 = 'VRP';
          break;
        case 'PLATINO-PLATINO SANTANDER':
          fiestaRewardsCode1 = 'VRP';
          break;
        case 'BLACK':
          fiestaRewardsCode1 = 'FRB';
          break;
        case 'OMNIA':
          fiestaRewardsCode1 = 'FRO';
          break;
        default:
          fiestaRewardsCode1 = 'NOR';
      }

    //poner la imagen de bandera
      if (fiestaRewardsCode1 === 'FR' || fiestaRewardsCode1 === 'FRC') {
              this.srcImageFRCard = (lang === 'es' ? 1 : 2);
            }
            if (fiestaRewardsCode1 === 'VRO') {
              this.srcImageFRCard = (lang === 'es' ? 3 : 4);
            }
            if (fiestaRewardsCode1 === 'VRP') {
              this.srcImageFRCard = (lang === 'es' ? 5 : 6);
            }
            if (fiestaRewardsCode1 === 'FRB') {
              this.srcImageFRCard = (lang === 'es' ? 7 : 8);
            }
            if (fiestaRewardsCode1 === 'FRO') {
              this.srcImageFRCard = (lang === 'es' ? 9 : 10);
            }


            var informacionHard= {
              "fiestaRewardsPartnerType": "SOCIO FR " + localStorage.getItem('Tier').toUpperCase(),
              "fiestaRewardsCode": fiestaRewardsCode1,
              "fiestaRewardsAccountNumber" : localStorage.getItem('membernumber'),
              "fiestaRewardsBalance" : localStorage.getItem('availablePoints')
            }
              
            this.infoFR = informacionHard;
            this.rewardsCode = informacionHard.fiestaRewardsCode;
            this.rewardsNumber = localStorage.getItem('membernumber');

            this.enableRewards = false;
            this.banLoaderFR = false;
            setTimeout(() => {
              this.banMemFR = true;
            }, 10);

            localStorage.removeItem("Tier");
            localStorage.removeItem("membernumber");
            //localStorage.removeItem("availablePoints");
      
    }
  //  END KB49419
    },
    setDataPersonalH1: function () {
      let ls = new SecureLS({ encodingType: 'aes' });
      let dataPersonalH1 = {};
      //KB
     /* var tmpagentNumber = this.agentNumber.replace("|", "");
      var tmpdataPersonalH1 = this.habitacion1.tituloDado.replace("|", "");
      var  tmpsimpleName = this.simpleName.replace("|", "");
      var tmpfatherSurname = this.fatherSurname.replace("|", "");
      var motherSurname = this.motherSurname.replace("|", "");
      this.agentNumber= tmpagentNumber;
      console.log("VALUE this.agentNumber",this.agentNumber);*/
      dataPersonalH1.perfil = this.habitacion1.search;
      dataPersonalH1.givenName = this.habitacion1.tituloDado;
      dataPersonalH1.simpleName = this.simpleName.toUpperCase();
      dataPersonalH1.fatherSurname = this.fatherSurname.toUpperCase();
      dataPersonalH1.motherSurname = this.motherSurname != null ? this.motherSurname.toUpperCase() : "";
      dataPersonalH1.agentNumber = this.agentNumber != null ? this.agentNumber.toUpperCase() : "";
      if (this.banMemFR) {
        dataPersonalH1.rewardsNumber = this.rewardsNumber != null ? this.rewardsNumber.toUpperCase() : "";
      } else {
        dataPersonalH1.rewardsNumber = '';
      }
      dataPersonalH1.apreciation = this.apreciation != null ? this.apreciation.toUpperCase() : "";
      dataPersonalH1.costCenter = this.costCenter != null ? this.costCenter.toUpperCase() : "";
      dataPersonalH1.guestProfileId = (this.banderita ? '' : this.mainGuestProfileId)
      dataPersonalH1.nameForService = this.nameForService
      dataPersonalH1.middleNameForService = this.middleNameForService
      dataPersonalH1.titleNumberForReservationRequest = this.titleNumberForReservationRequest
      dataPersonalH1.codigoFiestaReward = this.rewardsCode

      ls.set('dataPersonalH1', dataPersonalH1);
    },
    sendProformH1() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let sendProformH1 = {};
      sendProformH1.sendProformH1 = this.sendProform;
      ls.set('sendProformH1', sendProformH1);
    },
    setContactDataH1() {
      /*if (!this.habitacion1.numTelefonico){
        //return;
        console.log("entra")
      }*/
      let ls = new SecureLS({ encodingType: 'aes' });
      let contactDataH1 = {};
      contactDataH1.stateCode = this.stateCodeForReservationRequest

      contactDataH1.countryCode = this.countryCodeForReservationRequest

      contactDataH1.saveNewProfileH1 = this.saveNewProfileH1;
      contactDataH1.telephoneType = this.pickedTelelefonoCelular;
      contactDataH1.emailAlter = this.habitacion1.mailContactoConfirmacion
      contactDataH1.phoneNumber = this.numeroTelNew;
      contactDataH1.areaCode = this.codePaisNew2;
      contactDataH1.email = this.habitacion1.mailContacto;
      contactDataH1.address = this.pickedDireccion;
      contactDataH1.streetNumber = this.street != null ? this.street.toUpperCase() : "";
      contactDataH1.town = this.localityF != null ? this.localityF.toUpperCase() : "";
      contactDataH1.postCode = this.zipCode != null ? this.zipCode.toUpperCase() : "";
      contactDataH1.country = this.habitacion1.paisSeleccionado;
      contactDataH1.state = this.habitacion1.estadoSeleccionado;
      contactDataH1.checkIn = this.habitacion1.horaInSeleccionado;
      contactDataH1.checkOut = this.habitacion1.horaOutSeleccionado;
      contactDataH1.tripPurpose = this.habitacion1.pickedPropositos;
      ls.set('contactDataH1', contactDataH1);

      console.log("ls.get('datosHabHotSelected');" + JSON.stringify(ls.get('contactDataH1')));
    },

    setContactDataH2() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let contactDataH2 = {};
      contactDataH2.email = this.habitacion2.mailContacto;
      contactDataH2.saveNewProfileH2 = this.saveNewProfileH2;

      ls.set('contactDataH2', contactDataH2);

    },

    setContactDataH3() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let contactDataH3 = {};
      contactDataH3.saveNewProfileH3 = this.saveNewProfileH3;

      contactDataH3.email = this.habitacion3.mailContacto;
      ls.set('contactDataH3', contactDataH3);

    },

    setContactDataH4() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let contactDataH4 = {};
      contactDataH4.saveNewProfileH4 = this.saveNewProfileH4;

      contactDataH4.email = this.habitacion4.mailContacto;
      ls.set('contactDataH4', contactDataH4);

    },

    setContactDataH5() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let contactDataH5 = {};
      contactDataH5.saveNewProfileH5 = this.saveNewProfileH5;

      contactDataH5.email = this.habitacion5.mailContacto;
      if (contactDataH5.email == "undefined" || contactDataH5.email == null) {
        contactDataH5.email = ""
      }
      ls.set('contactDataH5', contactDataH5);

    },
    setCompanyDataH1() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let companyDataH1 = {};
      companyDataH1.name = this.company1Name.toUpperCase();
      companyDataH1.lastName = this.company1LastName.toUpperCase();
      companyDataH1.secondLastName = this.company1SecondLastName.toUpperCase();
      companyDataH1.email = this.email1;
      ls.set('CompanyDataH1', companyDataH1);
    },
    setRequirementsDataH1() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let requirementsDataH1 = {};

      var listTemp1 = [];
      if (this.listRequeriment.habitacion != null) {
        for (var list of this.listRequeriment.habitacion.requirementResponseList) {
          for (var list1 of this.habitacion1.selected) {
            if (list.requirementCode === list1) {
              listTemp1.push(list.requirementName);
            }
          }
        }
      }

      var listTemp2 = [];
      if (this.listRequeriment.extras != null) {
        for (var list of this.listRequeriment.extras.requirementResponseList) {
          for (var list1 of this.habitacion1.selectedExtra) {
            if (list.requirementCode === list1) {
              listTemp2.push(list.requirementName);
            }
          }
        }
      }

      var listTemp3 = '';
      if (this.listRequeriment.piso != null) {
        for (var list of this.listRequeriment.piso.requirementResponseList) {
          if (list.requirementCode === this.habitacion1.pickedPiso) {
            listTemp3 = list.requirementName;
          }
        }
      }

      var listTemp4 = '';
      if (this.listRequeriment.fumar != null) {
        for (var list of this.listRequeriment.fumar.requirementResponseList) {
          if (list.requirementCode === this.habitacion1.pickedFumar) {
            listTemp4 = list.requirementName;
          }
        }
      }

      requirementsDataH1.preferences = this.habitacion1.selected
      requirementsDataH1.preferencesText = listTemp1.join(', ');

      requirementsDataH1.extraPreferences = this.habitacion1.selectedExtra
      requirementsDataH1.extraPreferencesText = listTemp2.join(', ');
      requirementsDataH1.floorPreferences = this.habitacion1.pickedPiso
      requirementsDataH1.floorPreferencesText = listTemp3;
      requirementsDataH1.smokingPreferences = this.habitacion1.pickedFumar
      requirementsDataH1.smokingPreferencesText = listTemp4;
      requirementsDataH1.preferenciasTexto = requirementsDataH1.preferencesText.concat(", " + requirementsDataH1.extraPreferencesText).concat(", " + requirementsDataH1.floorPreferencesText).concat(", " + requirementsDataH1.smokingPreferencesText)
      if (requirementsDataH1.preferenciasTexto == null || requirementsDataH1.preferenciasTexto == ", " || requirementsDataH1.preferenciasTexto == ", , " || requirementsDataH1.preferenciasTexto == ", , , " || requirementsDataH1.preferenciasTexto == ", , , , ") {
        requirementsDataH1.preferenciasTexto = ""
      }
      if (requirementsDataH1.extraPreferences == null) {
        requirementsDataH1.extraPreferences = []
      }

      ls.set('requirementsDataH1', requirementsDataH1);
    },

    setRequirementsDataH2() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let requirementsDataH2 = {};

      var listTemp1 = [];
      if (this.listRequeriment.habitacion != null) {
        for (var list of this.listRequeriment.habitacion.requirementResponseList) {
          for (var list1 of this.habitacion2.selected) {
            if (list.requirementCode === list1) {
              listTemp1.push(list.requirementName);
            }
          }
        }
      }

      var listTemp2 = [];
      if (this.listRequeriment.extras != null) {
        for (var list of this.listRequeriment.extras.requirementResponseList) {
          for (var list1 of this.habitacion2.selectedExtra) {
            if (list.requirementCode === list1) {
              listTemp2.push(list.requirementName);
            }
          }
        }
      }

      var listTemp3 = '';
      if (this.listRequeriment.piso != null) {
        for (var list of this.listRequeriment.piso.requirementResponseList) {
          if (list.requirementCode === this.habitacion2.pickedPiso) {
            listTemp3 = list.requirementName;
          }
        }
      }

      var listTemp4 = '';
      if (this.listRequeriment.fumar != null) {
        for (var list of this.listRequeriment.fumar.requirementResponseList) {
          if (list.requirementCode === this.habitacion2.pickedFumar) {
            listTemp4 = list.requirementName;
          }
        }
      }

      requirementsDataH2.preferences = this.habitacion2.selected
      requirementsDataH2.preferencesText = listTemp1.join(', ');
      requirementsDataH2.extraPreferences = this.habitacion2.selectedExtra
      requirementsDataH2.extraPreferencesText = listTemp2.join(', ');
      requirementsDataH2.floorPreferences = this.habitacion2.pickedPiso
      requirementsDataH2.floorPreferencesText = listTemp3;
      requirementsDataH2.smokingPreferences = this.habitacion2.pickedFumar
      requirementsDataH2.smokingPreferencesText = listTemp4;
      requirementsDataH2.preferenciasTexto = requirementsDataH2.preferencesText.concat(", " + requirementsDataH2.extraPreferencesText).concat(", " + requirementsDataH2.floorPreferencesText).concat(", " + requirementsDataH2.smokingPreferencesText)
      if (requirementsDataH2.preferenciasTexto == null || requirementsDataH2.preferenciasTexto == ", " || requirementsDataH2.preferenciasTexto == ", , " || requirementsDataH2.preferenciasTexto == ", , , " || requirementsDataH2.preferenciasTexto == ", , , , ") {
        requirementsDataH2.preferenciasTexto = ""
      }
      if (requirementsDataH2.extraPreferences == null) {
        requirementsDataH2.extraPreferences = []
      }
      ls.set('requirementsDataH2', requirementsDataH2);
    },

    setRequirementsDataH3() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let requirementsDataH3 = {};

      var listTemp1 = [];
      if (this.listRequeriment.habitacion != null) {
        for (var list of this.listRequeriment.habitacion.requirementResponseList) {
          for (var list1 of this.habitacion3.selected) {
            if (list.requirementCode === list1) {
              listTemp1.push(list.requirementName);
            }
          }
        }
      }

      var listTemp2 = [];
      if (this.listRequeriment.extras != null) {
        for (var list of this.listRequeriment.extras.requirementResponseList) {
          for (var list1 of this.habitacion3.selectedExtra) {
            if (list.requirementCode === list1) {
              listTemp2.push(list.requirementName);
            }
          }
        }
      }

      var listTemp3 = '';
      if (this.listRequeriment.piso != null) {
        for (var list of this.listRequeriment.piso.requirementResponseList) {
          if (list.requirementCode === this.habitacion3.pickedPiso) {
            listTemp3 = list.requirementName;
          }
        }
      }

      var listTemp4 = '';
      if (this.listRequeriment.fumar != null) {
        for (var list of this.listRequeriment.fumar.requirementResponseList) {
          if (list.requirementCode === this.habitacion3.pickedFumar) {
            listTemp4 = list.requirementName;
          }
        }
      }

      requirementsDataH3.preferences = this.habitacion3.selected
      requirementsDataH3.preferencesText = listTemp1.join(', ');
      requirementsDataH3.extraPreferences = this.habitacion3.selectedExtra
      requirementsDataH3.extraPreferencesText = listTemp2.join(', ');
      requirementsDataH3.floorPreferences = this.habitacion3.pickedPiso
      requirementsDataH3.floorPreferencesText = listTemp3;
      requirementsDataH3.smokingPreferences = this.habitacion3.pickedFumar
      requirementsDataH3.smokingPreferencesText = listTemp4;
      requirementsDataH3.preferenciasTexto = requirementsDataH3.preferencesText.concat(", " + requirementsDataH3.extraPreferencesText).concat(", " + requirementsDataH3.floorPreferencesText).concat(", " + requirementsDataH3.smokingPreferencesText)
      if (requirementsDataH3.preferenciasTexto == null || requirementsDataH3.preferenciasTexto == ", " || requirementsDataH3.preferenciasTexto == ", , " || requirementsDataH3.preferenciasTexto == ", , , " || requirementsDataH3.preferenciasTexto == ", , , , ") {
        requirementsDataH3.preferenciasTexto = ""
      }
      if (requirementsDataH3.extraPreferences == null) {
        requirementsDataH3.extraPreferences = []
      }
      ls.set('requirementsDataH3', requirementsDataH3);
    },
    setRequirementsDataH4() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let requirementsDataH4 = {};

      var listTemp1 = [];
      if (this.listRequeriment.habitacion != null) {
        for (var list of this.listRequeriment.habitacion.requirementResponseList) {
          for (var list1 of this.habitacion4.selected) {
            if (list.requirementCode === list1) {
              listTemp1.push(list.requirementName);
            }
          }
        }
      }

      var listTemp2 = [];
      if (this.listRequeriment.extras != null) {
        for (var list of this.listRequeriment.extras.requirementResponseList) {
          for (var list1 of this.habitacion4.selectedExtra) {
            if (list.requirementCode === list1) {
              listTemp2.push(list.requirementName);
            }
          }
        }
      }

      var listTemp3 = '';
      if (this.listRequeriment.piso != null) {
        for (var list of this.listRequeriment.piso.requirementResponseList) {
          if (list.requirementCode === this.habitacion4.pickedPiso) {
            listTemp3 = list.requirementName;
          }
        }
      }

      var listTemp4 = '';
      if (this.listRequeriment.fumar != null) {
        for (var list of this.listRequeriment.fumar.requirementResponseList) {
          if (list.requirementCode === this.habitacion4.pickedFumar) {
            listTemp4 = list.requirementName;
          }
        }
      }

      requirementsDataH4.preferences = this.habitacion4.selected
      requirementsDataH4.preferencesText = listTemp1.join(', ');
      requirementsDataH4.extraPreferences = this.habitacion4.selectedExtra
      requirementsDataH4.extraPreferencesText = listTemp2.join(', ');
      requirementsDataH4.floorPreferences = this.habitacion4.pickedPiso
      requirementsDataH4.floorPreferencesText = listTemp3;
      requirementsDataH4.smokingPreferences = this.habitacion4.pickedFumar
      requirementsDataH4.smokingPreferencesText = listTemp4;
      requirementsDataH4.preferenciasTexto = requirementsDataH4.preferencesText.concat(", " + requirementsDataH4.extraPreferencesText).concat(", " + requirementsDataH4.floorPreferencesText).concat(", " + requirementsDataH4.smokingPreferencesText)
      if (requirementsDataH4.preferenciasTexto == null || requirementsDataH4.preferenciasTexto == ", " || requirementsDataH4.preferenciasTexto == ", , " || requirementsDataH4.preferenciasTexto == ", , , " || requirementsDataH4.preferenciasTexto == ", , , , ") {
        requirementsDataH4.preferenciasTexto = ""
      }

      if (requirementsDataH4.extraPreferences == null) {
        requirementsDataH4.extraPreferences = []
      }
      ls.set('requirementsDataH4', requirementsDataH4);
    },

    setRequirementsDataH5() {
      let ls = new SecureLS({ encodingType: 'aes' });
      let requirementsDataH5 = {};

      var listTemp1 = [];
      if (this.listRequeriment.habitacion != null) {
        for (var list of this.listRequeriment.habitacion.requirementResponseList) {
          for (var list1 of this.habitacion5.selected) {
            if (list.requirementCode === list1) {
              listTemp1.push(list.requirementName);
            }
          }
        }
      }

      var listTemp2 = [];
      if (this.listRequeriment.extras != null) {
        for (var list of this.listRequeriment.extras.requirementResponseList) {
          for (var list1 of this.habitacion5.selectedExtra) {
            if (list.requirementCode === list1) {
              listTemp2.push(list.requirementName);
            }
          }
        }
      }

      var listTemp3 = '';
      if (this.listRequeriment.piso != null) {
        for (var list of this.listRequeriment.piso.requirementResponseList) {
          if (list.requirementCode === this.habitacion5.pickedPiso) {
            listTemp3 = list.requirementName;
          }
        }
      }

      var listTemp4 = '';
      if (this.listRequeriment.fumar != null) {
        for (var list of this.listRequeriment.fumar.requirementResponseList) {
          if (list.requirementCode === this.habitacion5.pickedFumar) {
            listTemp4 = list.requirementName;
          }
        }
      }

      requirementsDataH5.preferences = this.habitacion5.selected
      requirementsDataH5.preferencesText = listTemp1.join(', ');
      requirementsDataH5.extraPreferences = this.habitacion5.selectedExtra
      requirementsDataH5.extraPreferencesText = listTemp2.join(', ');
      requirementsDataH5.floorPreferences = this.habitacion5.pickedPiso
      requirementsDataH5.floorPreferencesText = listTemp3;
      requirementsDataH5.smokingPreferences = this.habitacion5.pickedFumar
      requirementsDataH5.smokingPreferencesText = listTemp4;
      requirementsDataH5.preferenciasTexto = requirementsDataH5.preferencesText.concat(", " + requirementsDataH5.extraPreferencesText).concat(", " + requirementsDataH5.floorPreferencesText).concat(", " + requirementsDataH5.smokingPreferencesText)
      if (requirementsDataH5.preferenciasTexto == null || requirementsDataH5.preferenciasTexto == ", " || requirementsDataH5.preferenciasTexto == ", , " || requirementsDataH5.preferenciasTexto == ", , , " || requirementsDataH5.preferenciasTexto == ", , , , ") {
        requirementsDataH5.preferenciasTexto = ""
      }
      if (requirementsDataH5.extraPreferences == null) {
        requirementsDataH5.extraPreferences = []
      }
      ls.set('requirementsDataH5', requirementsDataH5);
    },

    setDataPersonalH2: function () {
      if (!this.hideRequirements) {
        this.habitacion2.datosContacto = false;
        this.formulario2.contacto = true;
      }
      let ls = new SecureLS({ encodingType: 'aes' });
      let dataPersonalH2 = {};
      dataPersonalH2.search = this.habitacion2.search;
      dataPersonalH2.tituloDado = this.habitacion2.tituloDado;
      dataPersonalH2.nombres = this.habitacion2.nombres.toUpperCase();
      dataPersonalH2.apellidoP = this.habitacion2.apellidoP.toUpperCase();
      dataPersonalH2.apellidoM = this.habitacion2.apellidoM.toUpperCase();
      dataPersonalH2.middleNameForService = this.middleNameForService2

      ls.set('dataPersonalH2', dataPersonalH2);
    },
    setDataPersonalH3: function () {
      if (!this.hideRequirements) {
        this.habitacion3.datosContacto = false;
        this.formulario3.contacto = true;
      }
      let ls = new SecureLS({ encodingType: 'aes' });
      let dataPersonalH3 = {};
      dataPersonalH3.search = this.habitacion3.search;
      dataPersonalH3.tituloDado = this.habitacion3.tituloDado;
      dataPersonalH3.nombres = this.habitacion3.nombres.toUpperCase();
      dataPersonalH3.apellidoP = this.habitacion3.apellidoP.toUpperCase();
      dataPersonalH3.apellidoM = this.habitacion3.apellidoM.toUpperCase();
      dataPersonalH3.middleNameForService = this.middleNameForService3

      ls.set('dataPersonalH3', dataPersonalH3);
    },
    setDataPersonalH4: function () {
      if (!this.hideRequirements) {
        this.habitacion4.datosContacto = false;
        this.formulario4.contacto = true;
      }
      let ls = new SecureLS({ encodingType: 'aes' });
      let dataPersonalH4 = {};
      dataPersonalH4.search = this.habitacion4.search;
      dataPersonalH4.tituloDado = this.habitacion4.tituloDado;
      dataPersonalH4.nombres = this.habitacion4.nombres.toUpperCase();
      dataPersonalH4.apellidoP = this.habitacion4.apellidoP.toUpperCase();
      dataPersonalH4.apellidoM = this.habitacion4.apellidoM.toUpperCase();
      dataPersonalH4.middleNameForService = this.middleNameForService4

      ls.set('dataPersonalH4', dataPersonalH4);
    },
    setDataPersonalH5: function () {
      if (!this.hideRequirements) {
        this.habitacion5.datosContacto = false;
        this.formulario5.contacto = true;
      }
      let ls = new SecureLS({ encodingType: 'aes' });
      let dataPersonalH5 = {};
      dataPersonalH5.search = this.habitacion5.search;
      dataPersonalH5.tituloDado = this.habitacion5.tituloDado;
      dataPersonalH5.nombres = this.habitacion5.nombres.toUpperCase();
      dataPersonalH5.apellidoP = this.habitacion5.apellidoP.toUpperCase();
      dataPersonalH5.apellidoM = this.habitacion5.apellidoM.toUpperCase();
      dataPersonalH5.middleNameForService = this.middleNameForService5

      ls.set('dataPersonalH5', dataPersonalH5);
    },
    isEmailValid: function () {
      return (this.email1 == "") ? "" : (this.reg.test(this.email1)) ? this.turnText = false : this.turnText = true;
    },
    isEmailValidRoom2: function () {
      return (this.habitacion2.mailContacto == "") ? "" : (this.reg.test(this.habitacion2.mailContacto)) ? this.turnTextRoom2 = false : this.turnTextRoom2 = true;
    },
    isEmailValidRoom3: function () {
      return (this.habitacion3.mailContacto == "") ? "" : (this.reg.test(this.habitacion3.mailContacto)) ? this.turnTextRoom3 = false : this.turnTextRoom3 = true;
    },
    isEmailValidRoom4: function () {
      return (this.habitacion4.mailContacto == "") ? "" : (this.reg.test(this.habitacion4.mailContacto)) ? this.turnTextRoom4 = false : this.turnTextRoom4 = true;
    },
    isEmailValidRoom5: function () {
      return (this.habitacion5.mailContacto == "") ? "" : (this.reg.test(this.habitacion5.mailContacto)) ? this.turnTextRoom5 = false : this.turnTextRoom5 = true;
    },
    closeExpiredModal() {
      this.isExpiredModalVisible = false
      var ls = new SecureLS({ encodingType: 'aes' });
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: 'Login' })
    },
    requerimientosSuplement() {
      var ls = new SecureLS({ encodingType: 'aes' });
      const datosHabHotSelected = ls.get('datosHabHotSelected');
      var data = {
        hotelCode: datosHabHotSelected.data.habitacion.hotelCode,
        currencyCode: datosHabHotSelected.data.habitacion.currencyCode,
        arrivalDate: datosHabHotSelected.data.habitacion.beautiDateInput,
        departureDate: datosHabHotSelected.data.habitacion.beautiDateOutput,
        contractCode: datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.contractCode,
        numAdults: datosHabHotSelected.data.habitacion.totalAdults,
        numChildren: datosHabHotSelected.data.habitacion.totalChildren,
        numRooms: datosHabHotSelected.data.habitacion.totalRooms
      }
      if (ls.get('supplement') == null || ls.get('supplement') == '' || ls.get('supplement') == undefined) {
        GlobalServices._consultaSuplementos(data, ls.get('Token').data, ls.get('Language').data).then(responseSup => {
          if (responseSup.status == 200) {
            ls.set('supplement', responseSup);
            this.suplement(responseSup);
          }
        }).catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          if (error.status == 401) {
            this.sesionClose();
          }
        });
      } else {
        this.suplement(ls.get('supplement'));
      }
      if (ls.get('requeriment') === null || ls.get('requeriment') === '' || ls.get('requeriment') === undefined) {
        GlobalServices._consultaRequerimientos(datosHabHotSelected.data.habitacion.hotelCode, ls.get('Token').data, ls.get('Language').data).then(responseReq => {
          if (responseReq.status === 200) {
            this.hideRequirements = true

            ls.set('requeriment', responseReq);
            this.dataRequeriment = responseReq.data;
            this.requeriment(this.dataRequeriment);
          }
        }).catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          if (error.status === 404) {
            this.hideRequirements = false
          }
          if (error.status === 401) {
            this.sesionClose();
          }
        });
      } else {
        this.hideRequirements = true
        this.dataRequeriment = ls.get('requeriment').data;
        this.requeriment(this.dataRequeriment);
      }
      this.suplementosOpcionales(datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.rateOptionalSupplementResponseList);
    },
    suplement(dataSupl) {
      let distributedSupl = []
      if (dataSupl.data.supplementMandatoryResponseList.length === 0) {
        this.banSuplement = false;
        // Getting mandatory supplements from availibility
        var nightsSuple = this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses
        for (var i = 0; i < nightsSuple.length; i++) {
          if (nightsSuple[i].rateMandatorySupplementResponseList != null && nightsSuple[i].rateMandatorySupplementResponseList.length != 0) {
            for (var j = 0; j < nightsSuple[i].rateMandatorySupplementResponseList.length; j++) {
              if (distributedSupl.length === 0) {
                distributedSupl.push({
                  id: 1,
                  name: nightsSuple[i].rateMandatorySupplementResponseList[j].supplementName,
                  quantity: nightsSuple[i].rateMandatorySupplementResponseList[j].numSuppleCharged
                })
              } else {
                for (var z = 0; z < distributedSupl.length; z++) {
                  if (distributedSupl[z].name === nightsSuple[i].rateMandatorySupplementResponseList[j].supplementName) {
                    let sum = nightsSuple[i].rateMandatorySupplementResponseList[j].numSuppleCharged + distributedSupl[z].quantity
                    distributedSupl[z].quantity = sum
                  } else {
                    const checkSuppleName = obj => obj.name == nightsSuple[i].rateMandatorySupplementResponseList[j].supplementName;
                    if (!distributedSupl.some(checkSuppleName)) {
                      distributedSupl.push({
                        id: distributedSupl.length + 1,
                        name: nightsSuple[i].rateMandatorySupplementResponseList[j].supplementName,
                        quantity: nightsSuple[i].rateMandatorySupplementResponseList[j].numSuppleCharged - 1
                      })
                    }
                  }
                }
              }
            }
            this.banSuplement = true;
          }
        }
        for (var i = 0; i < distributedSupl.length; i++) {
          this.descriptionMS += `${distributedSupl[i].quantity}`
          this.descriptionMS += " "
          this.descriptionMS += `${distributedSupl[i].name}, `
        }
        if (this.descriptionMS.slice(-1) == " ") {
          this.descriptionMS = this.descriptionMS.substring(0, this.descriptionMS.length - 1);
        }
        if (this.descriptionMS.slice(-1) == ",") {
          this.descriptionMS = this.descriptionMS.substring(0, this.descriptionMS.length - 1);
        }
        // Getting mandatory supplements from availibility
      } else {
        this.listSuplement = dataSupl.data.supplementMandatoryResponseList;
        // Set up mandatory texts
        for (var i = 0; i < this.listSuplement.length; i++) {
          this.descriptionMS += `${this.listSuplement[i].totalQuantity}`
          this.descriptionMS += " "
          this.descriptionMS += `${this.listSuplement[i].description}`
          this.descriptionMS += "  "
        }
        // Set up mandatory texts
        this.banSuplement = true;
      }
      this.ls.set("descriptionMS", this.descriptionMS)
    },
    requeriment(dataReq) {
      var lisTem = {
        habitacion: null,
        extras: null,
        piso: null,
        fumar: null
      };
      var listTemp2 = [];
      for (var dat of dataReq) {
        listTemp2 = [];
        for (let i = 0; i < dat.requirementResponseList.length; i++) {
          var tem = { id: dat.requirementResponseList[i].requirementCode, name: dat.requirementResponseList[i].requirementName, code: dat.requirementResponseList[i].requirementCode };
          listTemp2.push(tem);
        }
        if (dat.requirementType.toLowerCase().search('habitación') > -1 || dat.requirementType.toLowerCase().search('room') > -1) {
          lisTem.habitacion = dat;
          this.habitacion1.typeRoomsPreferents = listTemp2;
          this.habitacion2.typeRoomsPreferents = listTemp2;
          this.habitacion3.typeRoomsPreferents = listTemp2;
          this.habitacion4.typeRoomsPreferents = listTemp2;
          this.habitacion5.typeRoomsPreferents = listTemp2;
        }
        if (dat.requirementType.toLowerCase().search('extras') > -1) {
          lisTem.extras = dat;
          this.habitacion1.typeExtrasPreferents = listTemp2;
          this.habitacion2.typeExtrasPreferents = listTemp2;
          this.habitacion3.typeExtrasPreferents = listTemp2;
          this.habitacion4.typeExtrasPreferents = listTemp2;
          this.habitacion5.typeExtrasPreferents = listTemp2;
        }
        if (dat.requirementType.toLowerCase().search('piso') > -1 || dat.requirementType.toLowerCase().search('floor') > -1) {
          lisTem.piso = dat;
        }
        if (dat.requirementType.toLowerCase().search('fumar') > -1 || dat.requirementType.toLowerCase().search('smoking') > -1) {
          lisTem.fumar = dat;
        }
      }
      this.listRequeriment = lisTem;
    },
    suplementosOpcionales(listRequeOpcionales) {
      if (listRequeOpcionales.length === 0) {
        this.banReqOpcionales = false;
      } else {
        this.listRequeOpcionales = listRequeOpcionales;
        this.banReqOpcionales = true;
      }
    },
    clicCheckBoxReqOpcional(e, reqOpcional, index) {
      if (e.target.checked == false) {
        for (let i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
          if (this.listRequeOpcionalesSeleccionados[i].index === index) {
            this.listRequeOpcionalesSeleccionados.splice(i, 1);
          }
        }
      } else {
        this.listRequeOpcionalesSeleccionados.push({ index: index, reqOpcional });
      }
      var opSuE = []
      for (var i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
        opSuE.push(this.listRequeOpcionalesSeleccionados[i].reqOpcional)
      }
      this.ls.set('opSuE', opSuE)
      this.ls.set('updateTotalStay', this.listRequeOpcionalesSeleccionados)
      this.$store.commit('updateTotalStay', { optionalSupplementsObject: this.ls.get('updateTotalStay') })

    },
    sesionClose() {
      this.isExpiredModalVisible = true
    },
    goPayments() {
      this.setCompanyDataH1();
      if (this.infoReserva.data.specialMessage.length != 0) {
        this.titleConsiEspecial = (this.infoReserva.data.mojito ? i18n.t('language.posadasCorporate.modales.EspecificacionesEspecialesCuba.title') : i18n.t('language.posadasCorporate.reservacionesRegistro.modalTitleConsiEspe'))
        if (this.infoReserva.data.mojito) {
          this.mojito = this.infoReserva.data.mojito;
          this.bodyConsiEspecial = this.infoReserva.data.specialMessage[0].split('.');
        } else {
          this.bodyConsiEspecial = this.infoReserva.data.specialMessage[0];
        }
        this.isModalConsiEspecial = true;
      } else {
        this.$router.push({ name: 'ReservacionesMetodosPago' })
      }

    },
     // INI KB48464
    showModalTelephone() {
      
      if (this.flagIsModalTelephone) {
        if (this.cellNumber == "" && this.homeNumber == "" && this.officeNumber == "") {
          if (this.pickedTelelefonoCelular == "MOB") {
            this.isModalTelephone = true;
            this.flagIsModalTelephone = false;
          }
        }
        else if (this.cellNumber !== "" && this.homeNumber == "" && this.officeNumber == "") {
          this.isModalTelephone = true;
          this.flagIsModalTelephone = false;
        }
        else if (this.cellNumber == "" && this.homeNumber !== "" && this.officeNumber == "") {
          if (this.pickedTelelefonoCelular == "MOB") {
            this.isModalTelephone = true;
            this.flagIsModalTelephone = false;
          }
        }
        else{
            if (this.pickedTelelefonoCelular == "MOB") {
              this.isModalTelephone = true;
              this.flagIsModalTelephone = false;
            }
        }


        //;
      }
	  },
	  closeModalTelephone() {
        this.isModalTelephone = false;
    },
    resetFlagModalTelephone() {
      this.flagIsModalTelephone = true;
    },
    falseFlagModalTelephone() {
      this.flagIsModalTelephone = false;
      // FIN KB48464
    },
    
    closeModalConsiEspecial() {
      this.isModalConsiEspecial = false;
      setTimeout(() => {
        this.$router.push({ name: 'ReservacionesMetodosPago' })
      }, 10);
    },
    privacyNav() {
      (this.ls.get('Language').data == 'es' ? window.open(process.env.VUE_APP_POLICIES, '_blank') : window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
    },
    clearLocalStorage() {
      this.isExpiredModalVisible = true
    },
    callGuestDetail(guestProfileId, fiestaRewardsNumber) {
      if (fiestaRewardsNumber == null) {
        fiestaRewardsNumber = ''
      }
      /** Implementar llamado a servicio de consulta detalle de perfil de huesped*/
      axios.post(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_GUESTDETAIL, {
        guestProfileId: guestProfileId,
        fiestaRewardsNumber: fiestaRewardsNumber
      }, {
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': 'Bearer ' + this.token,
          'Content-Type': 'application/json',
          'Accept-Language': this.language.data,
        }
      })
        .then(res => {
          this.ls.set('GuestProfileDetail', { data: res.data.response });
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            this.cellNumber = ""
            this.homeNumber = ""
            this.officeNumber = ""
            this.pickedTelelefonoCelular = ""
            this.habitacion1.numTelefonico = ""
            //KB47296 Start
            this.habitacion1.areaCode = ""
            this.habitacion1.nationalNumber = ""
            //KB47296 End
            //  PHONE
            if (resObject.data.response.phone != null && resObject.data.response.phone.length != 0) {
              for (var i = 0; i < resObject.data.response.phone.length; i++) {
                if (resObject.data.response.phone[i].type == "MOB") {
                  if (resObject.data.response.phone[i].number != null) {
                    this.habitacion1.numTelefonico = resObject.data.response.phone[i].number
                    this.pickedTelelefonoCelular = 'MOB'
                    this.cellNumber = resObject.data.response.phone[i].number
                  }
                }
                if (resObject.data.response.phone[i].type == "HOM") {
                  if (resObject.data.response.phone[i].number != null) {
                    this.habitacion1.numTelefonico = resObject.data.response.phone[i].number
                    this.pickedTelelefonoCelular = 'HOM'
                    this.homeNumber = resObject.data.response.phone[i].number                    
                  }
                }
                if (resObject.data.response.phone[i].type == "BUS") {
                  if (resObject.data.response.phone[i].number != null) {
                    this.habitacion1.numTelefonico = resObject.data.response.phone[i].number
                    this.pickedTelelefonoCelular = 'BUS'
                    this.officeNumber = resObject.data.response.phone[i].number
                  }
                }
              }
            }
            var phonesService = {
              countryAccessCode: "",
              phoneExtension: "",
              phoneNumber: this.codePaisNew
            }
            var ls = new SecureLS({ encodingType: 'aes' });
            ls.set('jobPhonesForReservationRequest', { data: phonesService })
            this.finding = this.codePaisNew
          } else {
          }
        })
        .catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          } else {
          }
        })
    },
    initializing() {
      var ls = new SecureLS({ encodingType: 'aes' });
      var a = ''
      a = ls.get('Token')
      var local1 = ls.get('datosHabHotSelected')
      this.infoReserva = ls.get('datosHabHotSelected');
      var privacy = ls.get('datosHabHotSelected');
      if (ls.get('Profile').data.email == "reservacionescorporate@posadas.com") {
        this.emailIsRepeated = false
      } else {
        this.emailIsRepeated = true
        this.emailProfile = ls.get('Profile').data.email
      }
      if (privacy.data.politicas == undefined || privacy.data.politicas == null) {
        const detailHotelInfo = ls.get('DetailHotelInfo').data.response;
        const availibilityRequest2 = ls.get('availibilityRequest').data;
        const profile2 = ls.get('Profile').data;
        const datosHabHotSelected = ls.get('datosHabHotSelected');
        let bodyRatePolicy = {
          hotelCode: '',
          arrivalDate: '',
          departureDate: '',
          contractCode: '',
          contractType: null,
          currencyCode: '',
          showRates: null,
          showPublicRates: null,
          hasCombinedRate: null,
          dailyRate: null,
          totalRate: null
        };
        bodyRatePolicy.hotelCode = detailHotelInfo.hotelCode;
        bodyRatePolicy.arrivalDate = availibilityRequest2.beautiDateInput;
        bodyRatePolicy.departureDate = availibilityRequest2.beautiDateOutput;
        bodyRatePolicy.contractCode = datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.contractCode;
        bodyRatePolicy.currencyCode = (availibilityRequest2.currencyCode === '' ? 'MXN' : availibilityRequest2.currencyCode);
        bodyRatePolicy.showRates = profile2.ratesPermissionsResponse.showRates;
        bodyRatePolicy.showPublicRates = profile2.ratesPermissionsResponse.showPublicRates;

        GlobalServices._consultaPoliticasTarifas(ls.get('Token').data, ls.get('Language').data, bodyRatePolicy).then(response => {
          if (response.status === 200) {
            privacy.data.politicas = response.data;
            this.privacyLink = privacy.data.politicas.privacyPolicyURL;
            ls.set('datosHabHotSelected', privacy);
          }
        }).catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          if (error.status === 401) {
            //token caduco
            this.sesionClose();
          }
        });
      } else {
        this.privacyLink = privacy.data.politicas.privacyPolicyURL;
      }
      var local2 = ls.get('BusquedaPorTarifaInfo')
      this.token = a.data.substr(1);
      this.language = ls.get('Language');
      //START KB56697 --- consultar los codigos de paises
      this.jsonPaises = LadasInternacionales;
      //END KB56697
      
      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY,
        {
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': 'Bearer ' + this.token,
            'Accept-Language': this.language.data,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            var intermidiate = resObject.data.response
            var intermidiate2 = []
            this.habitacion1.paises = []
            for (var i = 0; i < intermidiate.length; i++) {
              intermidiate2.push({ 'nombre': intermidiate[i].countryName, 'countryCode': intermidiate[i].countryCode })
            }
            this.habitacion1.paises = intermidiate2
            this.habitacion1.paises2 = intermidiate2

          }
        })
        .catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          }
        })
      // Fin de consultar paises
      if (this.selectedProfile == '') {
        this.simpleName = ''
        this.fatherSurname = ''
        this.motherSurname = ''
        this.agentNumber = ''
        this.rewardsNumber = ''
        this.apreciation = ''
        this.costCenter = ''
      }
      var availibilityRequest = ls.get('availibilityRequest');
      // Getting Slider Room #1
      if (availibilityRequest.data.totalRooms == 1) {
        this.showMainRoom = true
        this.showRemainingRooms = false
      }
      // Creating MAX two ROOMS, it's all good uop until now
      // don't move anything
      if (availibilityRequest.data.totalRooms > 1) {
        this.nombreChambres = []
        this.showMainRoom = true
        this.showRemainingRooms = true
        // Creating counter to fill number of sliders depending on number of rooms
        if (availibilityRequest.data.totalRooms > 2) {
          for (var i = 2; i <= 2; i++) {
            this.nombreChambres.push(
              {
                id: i
              }
            )
          }
        }
      }
      // ENDING TWO ROOMS
      // CREATING THREE ROOMS
      if (availibilityRequest.data.totalRooms > 2) {  // Realizing if I have 3 rooms at least
        this.turnRoom3 = true  // Turn ROOM #3 on
      } else {
        // If I don't have 3 ROOMS then turn room #3 off
        this.turnRoom3 = false
      }
      // ENDING 3 ROOMS
      // CREATING FOUR ROOMS
      if (availibilityRequest.data.totalRooms > 3) {  // Realizing if I have 3 rooms at least
        this.turnRoom4 = true  // Turn ROOM #3 on
      } else {
        // If I don't have 3 ROOMS then turn room #3 off
        this.turnRoom4 = false
      }
      // ENDING 4 ROOMS
      // CREATING FIVE ROOMS
      if (availibilityRequest.data.totalRooms > 4) {  // Realizing if I have 3 rooms at least
        this.turnRoom5 = true  // Turn ROOM #3 on
      } else {
        // If I don't have 3 ROOMS then turn room #3 off
        this.turnRoom5 = false
      }
      // ENDING 5 ROOMS
      // Fin de Slider chambre
      // Invoking WS guestProfile/{profileType}
      /** Implementar llamado a servicio de consulta perfiles de huespedes
       *
       * En esta URL
       {{DevHost}}/guestProfile/SOB
       del servicio guestProfile (editado)
       lo que dice “SOB” es un parametro que se saca del  perfil del usuario
       del que te preguntaba hace rato si se guarda en el localstorage
       El dato es este
       “profileType”:“SOB”
       configuration siempre va
       hotel/CODIGOHOTEL/configuration
       */
      var profile = ls.get('Profile');
      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_GUEST + `${profile.data.profileType}`,
        {
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': 'Bearer ' + this.token,
            'Accept-Language': this.language.data,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            this.banLoaderPerfiles = false;
            // Filling autocomplete for profiles
            var name = ''
            var middleName = ''
            var fatherSurname = ''
            var mother = ''
            var completeName
            this.perfiles = []
            var justName = ''
            for (var i = 0; i < resObject.data.response.length; i++) {
              name = resObject.data.response[i].name
              middleName = resObject.data.response[i].middleName
              fatherSurname = resObject.data.response[i].fatherSurname
              mother = resObject.data.response[i].motherSurname
              completeName = [name, middleName, fatherSurname, mother].filter(Boolean).join(" ");
              justName = [name, middleName].filter(Boolean).join(" ");
              //START 58667
              var telefono = "";
              if(resObject.data.response[i].phone.length != 0){
                  telefono = resObject.data.response[i].phone[0].number;
              }
             //END 58667
               this.habitacion1.perfiles.push({
                mainNameForService: name,
                middleNameForService: middleName,
                mailContacto: resObject.data.response[i].email,
                mailContactoConfirmacion: resObject.data.response[i].emailAlternative,
                nombre: completeName,
                fiestaRewardsNumber: resObject.data.response[i].fiestaRewardsNumber,
                guestProfileId: resObject.data.response[i].guestProfileId,
                simpleName: justName.toUpperCase(),
                fatherSurname: fatherSurname.toUpperCase(),
                motherSurname: mother != null ? mother.toUpperCase() : "",
                agentNumber: resObject.data.response[i].employeeNumber != null ? resObject.data.response[i].employeeNumber.toUpperCase() : "",
                rewardsNumber: resObject.data.response[i].fiestaRewardsNumber != null ? resObject.data.response[i].fiestaRewardsNumber.toUpperCase() : "",
                apreciation: resObject.data.response[i].apreciareClubNumber != null ? resObject.data.response[i].apreciareClubNumber.toUpperCase() : "",
                costCenter: resObject.data.response[i].costCenter != null ? resObject.data.response[i].costCenter.toUpperCase() : "",
                streetNameWithNumber: resObject.data.response[i].address.streetNameWithNumber.toUpperCase(),
                locality: resObject.data.response[i].address.colony != null ? resObject.data.response[i].address.colony.toUpperCase() : "",
                zipCode: resObject.data.response[i].address.zipCode != null ? resObject.data.response[i].address.zipCode.toUpperCase() : "",
                addressType: resObject.data.response[i].address.addressType,
                // COUNTRY
                country: resObject.data.response[i].address.country,
                // STATE
                state: resObject.data.response[i].address.state,
                //START KB54578 && 58667
                //numeroTelNew: resObject.data.response[i].phone[0].number
                numeroTelNew: telefono
                //END KB54578
              })
              
              this.habitacion2.perfiles = this.habitacion1.perfiles
              this.habitacion3.perfiles = this.habitacion1.perfiles

              this.habitacion4.perfiles = this.habitacion1.perfiles

              this.habitacion5.perfiles = this.habitacion1.perfiles

            }
            // Profiles autocomple done

          }
        })
        .catch(error => {
          this.banLoaderPerfiles = false;
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          } else {
          }
        })
      // Ending

    },
    //KB47296 Start
    handleValidatePhoneNumber(phoneObject){
     // console.log("@handleValidatePhoneNumber");
     // console.log(phoneObject);

      this.isDisabledContacto;
      if(phoneObject.countryCallingCode && phoneObject.nationalNumber && phoneObject.valid){
        this.habitacion1.areaCode = '+' + phoneObject.countryCallingCode;
        this.habitacion1.nationalNumber = phoneObject.nationalNumber;
        this.handleCountryChanged({dialCode: phoneObject.countryCallingCode});
      }

      if(this.habitacion1.nationalNumber === "" && this.habitacion1.areaCode === ""){
        this.habitacion1.numTelefonico = this.habitacion1.nationalNumber
      }
      
    },
    handleOnBlurPhoneNumber() {
      this.isDisabledContacto;
      if(this.habitacion1.areaCode && this.habitacion1.nationalNumber){
        this.habitacion1.numTelefonico = validatePhoneNumber(this.habitacion1.areaCode, this.habitacion1.nationalNumber, this.pickedTelelefonoCelular);
        this.forceRerender();
      }
      
    },
    handleCountryChanged(countryObject) {
      this.isDisabledContacto;

      if(countryObject.dialCode){
        this.habitacion1.areaCode = '+' + countryObject.dialCode;
      }      

      if(this.habitacion1.areaCode && this.habitacion1.nationalNumber){
        this.habitacion1.numTelefonico = validatePhoneNumber(this.habitacion1.areaCode, this.habitacion1.nationalNumber, this.pickedTelelefonoCelular);
      }
      
    },
    handleOnInputPhoneNumber(number, phoneObject) {
    //  console.log(number);
    //  console.log(phoneObject);
      
      if(phoneObject.countryCallingCode && phoneObject.nationalNumber){
        this.habitacion1.areaCode = '+' + phoneObject.countryCallingCode;
        this.habitacion1.nationalNumber = phoneObject.nationalNumber;
      }
      
      if(number === ""){
        this.habitacion1.areaCode = "";
        this.habitacion1.nationalNumber = "";
        this.habitacion1.numTelefonico = "";
      }
      
      this.isDisabledContacto;
    },
    forceRerender() {
      this.telInput += 1;
    },
    //KB47296 End
    // habitacion1.buscador
    cambiaValue(perfil, guestProfileId, perfilCompleto) {
      this.selectedProfile = guestProfileId
      return this.habitacion1.search = perfil;
    },
    cambiaTitulo(titulo) {
      return this.habitacion1.tituloDado = titulo;
    },
    cambiaPais(pais) {
      this.findingCountry = pais;
      this.banSelectedPais = true;
      for (var i = 0; i < this.habitacion1.paises.length; i++) {
        if (this.habitacion1.paises[i].nombre == pais) {
          this.countryCodeForReservationRequest = this.habitacion1.paises[i].countryCode
        }
      }
      
      return this.habitacion1.paisSeleccionado = pais;
    },
    cambiaTelefono(pais) {
      //console.log("cambiaTelefono"+ JSON.stringify((pais)));
      this.findingTelefono = pais.name;
      this.banSelectedTelefono = true;
      /*for (var i = 0; i < this.habitacion1.paises.length; i++) {
        if (this.habitacion1.paises[i].nombre == pais) {
          this.countryCodeForReservationRequest = this.habitacion1.paises[i].countryCode
        }
      }
*/ 
      this.codePaisNew2 = pais.lada;
      //this.habitacion1.numTelefonico = pais.name + " +" + pais.lada;
      return this.codePaisNew = pais.name + " +" + pais.lada;

    },
    cambiaEstado(estado) {

      //  this.habitacion1.estados
      for (var i = 0; i < this.habitacion1.estados.length; i++) {

        if (this.habitacion1.estados[i].stateName == estado) {

          this.stateCodeForReservationRequest = this.habitacion1.estados[i].stateCode
        }
      }

      return this.habitacion1.estadoSeleccionado = estado;
    },
    cambiaHoraIn(horaIn) {
      return this.habitacion1.horaInSeleccionado = horaIn;
    },
    cambiaHoraOut(horaOut) {
      return this.habitacion1.horaOutSeleccionado = horaOut;
    },
    //habitacion 2
    cambiaValueH2(perfil) {
      this.selectedProfile2 = perfil
      return this.habitacion2.search = perfil;
    },
    cambiaValueH3(perfil) {
      this.selectedProfile3 = perfil
      return this.habitacion3.search = perfil;
    },
    cambiaValueH4(perfil) {
      this.selectedProfile4 = perfil
      return this.habitacion4.search = perfil;
    },

    cambiaValueH5(perfil) {
      this.selectedProfile5 = perfil
      return this.habitacion5.search = perfil;
    },
    cambiaTituloH2(titulo) {
      return this.habitacion2.tituloDado = titulo;
    },
    cambiaTituloH3(titulo) {
      return this.habitacion3.tituloDado = titulo;
    },
    // tipos de habitacions
    handleType(e) {
      if (e.target.checked == false) {
        return this.habitacion1.typePreferent = '';
      } else {
        return this.habitacion1.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion');
      }
    },
    handleTypeSelect(e, type) {
      if (this.habitacion1.selected.length == 1) {
        let room = this.habitacion1.typeRoomsPreferents.find(room => room.id === this.habitacion1.selected[0]);
        this.habitacion1.typePreferent = room.name;
      } else if (this.habitacion1.selected.length > 1) {
        this.habitacion1.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
      } else if (this.habitacion1.selected.length < 1) {
        this.habitacion1.typePreferent = '';
      }
    },
    // tipos de preferencia extra
    handleTypeExtra(e) {
      if (e.target.checked == false) {
        return this.habitacion1.typePreferentExtra = '';
      } else {
        return this.habitacion1.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.extraPreferences') // 'Todas las preferencias extras';
      }
    },
    handleTypeSelectExtra(e, type) {
      if (this.habitacion1.selectedExtra.length == 1) {
        let room = this.habitacion1.typeExtrasPreferents.find(room => room.id === this.habitacion1.selectedExtra[0]);
        this.habitacion1.typePreferentExtra = room.name;
      } else if (this.habitacion1.selectedExtra.length > 1) {
        this.habitacion1.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.allExtraPreferences');
      } else if (this.habitacion1.selectedExtra.length < 1) {
        this.habitacion1.typePreferentExtra = '';
      }
    },
    // Habitacion2
    validaNumericos(event) {
    if(event.charCode >= 48 && event.charCode <= 57){
      return true;
     }
     return false;        
},
    // tipos de habitacions
    handleTypeH2(e) {
      if (e.target.checked == false) {
        return this.habitacion2.typePreferent = '';
      } else {
        return this.habitacion2.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion');
      }
    },
    handleTypeH3(e) {
      if (e.target.checked == false) {
        return this.habitacion3.typePreferent = '';
      } else {
        return this.habitacion3.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion');
      }
    },
    handleTypeH4(e) {
      if (e.target.checked == false) {
        return this.habitacion4.typePreferent = '';
      } else {
        return this.habitacion4.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion');
      }
    },
    handleTypeH5(e) {
      if (e.target.checked == false) {
        return this.habitacion5.typePreferent = '';
      } else {
        return this.habitacion5.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.todasPreferenciasHabitacion');
      }
    },
    handleTypeSelectH2(e, type) {
      if (this.habitacion2.selected.length == 1) {
        let room = this.habitacion2.typeRoomsPreferents.find(room => room.id === this.habitacion2.selected[0]);
        this.habitacion2.typePreferent = room.name;
      } else if (this.habitacion2.selected.length > 1) {
        this.habitacion2.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
      } else if (this.habitacion2.selected.length < 1) {
        this.habitacion2.typePreferent = '';
      }
    },
    handleTypeSelectH3(e, type) {
      if (e.target.checked == false) {
        this.habitacion3.typePreferent = '';
      } else {
        if (this.habitacion3.selected.length > 1) {
          this.habitacion3.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion3.typePreferent = type;
        }
      }
    },
    handleTypeSelectH4(e, type) {
      if (e.target.checked == false) {
        this.habitacion4.typePreferent = '';
      } else {
        if (this.habitacion4.selected.length > 1) {
          this.habitacion4.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion4.typePreferent = type;
        }
      }
    },
    handleTypeSelectH5(e, type) {
      if (e.target.checked == false) {
        this.habitacion5.typePreferent = '';
      } else {
        if (this.habitacion5.selected.length > 1) {
          this.habitacion5.typePreferent = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion5.typePreferent = type;
        }
      }
    },
    // tipos de preferencia extra
    handleTypeExtraH2(e) {
      if (e.target.checked == false) {
        return this.habitacion2.typePreferentExtra = '';
      } else {
        return this.habitacion2.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.extraPreferences') // 'Todas las preferencias extras';
      }
    },
    handleTypeExtraH3(e) {
      if (e.target.checked == false) {
        return this.habitacion3.typePreferentExtra = '';
      } else {
        return this.habitacion3.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.extraPreferences') // 'Todas las preferencias extras';
      }
    },
    handleTypeExtraH4(e) {
      if (e.target.checked == false) {
        return this.habitacion4.typePreferentExtra = '';
      } else {
        return this.habitacion4.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.extraPreferences') // 'Todas las preferencias extras';
      }
    },
    handleTypeExtraH5(e) {
      if (e.target.checked == false) {
        return this.habitacion5.typePreferentExtra = '';
      } else {
        return this.habitacion5.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.extraPreferences') // 'Todas las preferencias extras';
      }
    },
    handleTypeSelectExtraH2(e, type) {
      if (e.target.checked == false) {
        this.habitacion2.typePreferentExtra = '';
      } else {
        if (this.habitacion2.selectedExtra.length > 1) {
          this.habitacion2.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion2.typePreferentExtra = type;
        }
      }
    },
    handleTypeSelectExtraH3(e, type) {
      if (e.target.checked == false) {
        this.habitacion3.typePreferentExtra = '';
      } else {
        if (this.habitacion3.selectedExtra.length > 1) {
          this.habitacion3.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion3.typePreferentExtra = type;
        }
      }
    },
    handleTypeSelectExtraH4(e, type) {
      if (e.target.checked == false) {
        this.habitacion4.typePreferentExtra = '';
      } else {
        if (this.habitacion4.selectedExtra.length > 1) {
          this.habitacion4.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion4.typePreferentExtra = type;
        }
      }
    },
    handleTypeSelectExtraH5(e, type) {
      if (e.target.checked == false) {
        this.habitacion5.typePreferentExtra = '';
      } else {
        if (this.habitacion5.selectedExtra.length > 1) {
          this.habitacion5.typePreferentExtra = i18n.t('language.posadasCorporate.reservacionesRegistro.allRoomPreferences');
        } else {
          this.habitacion5.typePreferentExtra = type;
        }
      }
    },
    // Cerrar inputs
    outsideSearch(e) {
      this.habitacion1.buscador = false;
    },
    outsideTitulo(e) {
      this.habitacion1.titulo = false;
    },
    outsidePais(e) {
      this.habitacion1.pais = false;
    },
    outsideTelefono(e) {
      this.boleanTelefono = false;
    },
    outsideEstado(e) {
      this.habitacion1.estado = false;
    },
    outsideHoraIn(e) {
      this.habitacion1.horaIn = false;
    },
    outsideHoraOut(e) {
      this.habitacion1.horaOut = false;
    },
    outsideRoomPreferents(e) {
      this.habitacion1.roomPreferences = true;
    },
    openRoomPreferentType() {
      this.habitacion1.showRoomTypeMobile = true;
    },
    aplicarRoomtype() {
      this.habitacion1.showRoomTypeMobile = false;
    },
    outsidePreferentsExtra(e) {
      this.habitacion1.extraPreferences = true;
    },
    openExtraPreferentType() {
      this.habitacion1.showExtraTypeMobile = true;
    },
    aplicarExtratype() {
      this.habitacion1.showExtraTypeMobile = false;
    },
    // habitacion 2 cerrar inputs
    outsideSearchH2(e) {
      this.habitacion2.buscador = false;
    },
    outsideSearchH3(e) {
      this.habitacion3.buscador = false;
    },
    outsideSearchH4(e) {
      this.habitacion4.buscador = false;
    },
    outsideSearchH5(e) {
      this.habitacion5.buscador = false;
    },
    outsideTituloH2(e) {
      this.habitacion2.titulo = false;
    },
    outsideTituloH3(e) {
      this.habitacion3.titulo = false;
    },
    outsideTituloH4(e) {
      this.habitacion4.titulo = false;
    },
    outsideTituloH5(e) {
      this.habitacion5.titulo = false;
    },
    outsideRoomPreferentsH2(e) {
      this.habitacion2.roomPreferences = true;
    },
    outsideRoomPreferentsH3(e) {
      this.habitacion3.roomPreferences = true;
    },
    outsideRoomPreferentsH4(e) {
      this.habitacion4.roomPreferences = true;
    },
    outsideRoomPreferentsH5(e) {
      this.habitacion5.roomPreferences = true;
    },
    openRoomPreferentTypeH2() {
      this.habitacion2.showRoomTypeMobile = true;
    },
    openRoomPreferentTypeH3() {
      this.habitacion3.showRoomTypeMobile = true;
    },
    openRoomPreferentTypeH4() {
      this.habitacion4.showRoomTypeMobile = true;
    },
    openRoomPreferentTypeH5() {
      this.habitacion5.showRoomTypeMobile = true;
    },
    aplicarRoomtypeH2() {
      this.habitacion2.showRoomTypeMobile = false;
    },
    outsidePreferentsExtraH2(e) {
      this.habitacion2.extraPreferences = true;
    },
    outsidePreferentsExtraH3(e) {
      this.habitacion3.extraPreferences = true;
    },
    outsidePreferentsExtraH4(e) {
      this.habitacion4.extraPreferences = true;
    },
    outsidePreferentsExtraH5(e) {
      this.habitacion5.extraPreferences = true;
    },
    openExtraPreferentTypeH2() {
      this.habitacion2.showExtraTypeMobile = true;
    },
    openExtraPreferentTypeH3() {
      this.habitacion3.showExtraTypeMobile = true;
    },
    openExtraPreferentTypeH4() {
      this.habitacion4.showExtraTypeMobile = true;
    },
    openExtraPreferentTypeH5() {
      this.habitacion5.showExtraTypeMobile = true;
    },
    aplicarExtratypeH2() {
      this.habitacion2.showExtraTypeMobile = false;
    },
    /*Eventos para cambios en el ancho de la pagina*/
    getWindowWidth: function (event) {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowWidth > 736 ? this.device = 'desktop' : this.device = 'mobile';
    },
    // Replicar informacion de habitacion 1
    replicarInfo() {
      this.habitacion2.search = this.habitacion1.search
      this.habitacion2.tituloDado = this.habitacion1.tituloDado
      this.habitacion2.nombres = this.simpleName.toUpperCase()
      this.habitacion2.apellidoP = this.fatherSurname.toUpperCase()
      this.habitacion2.apellidoM = this.motherSurname != null ? this.motherSurname.toUpperCase() : ""
      this.habitacion2.pickedPiso = this.habitacion1.pickedPiso
      this.habitacion2.pickedFumar = this.habitacion1.pickedFumar
      this.habitacion2.typePreferent = this.habitacion1.typePreferent
      this.habitacion2.mailContacto = this.habitacion1.mailContacto
      this.habitacion2.mailContactoConfirmacion = this.habitacion1.mailContactoConfirmacion
      this.habitacion2.selected = this.habitacion1.selected
      this.habitacion2.typePreferentExtra = this.habitacion1.typePreferentExtra
      this.habitacion2.selectedExtra = this.habitacion1.selectedExtra
    },
    replicarInfo3() {
      this.habitacion3.search = this.habitacion1.search
      this.habitacion3.tituloDado = this.habitacion1.tituloDado
      this.habitacion3.nombres = this.simpleName.toUpperCase()
      this.habitacion3.apellidoP = this.fatherSurname.toUpperCase()
      this.habitacion3.apellidoM = this.motherSurname != null ? this.motherSurname.toUpperCase() : ""
      this.habitacion3.pickedPiso = this.habitacion1.pickedPiso
      this.habitacion3.pickedFumar = this.habitacion1.pickedFumar
      this.habitacion3.typePreferent = this.habitacion1.typePreferent
      this.habitacion3.mailContacto = this.habitacion1.mailContacto
      this.habitacion3.mailContactoConfirmacion = this.habitacion1.mailContactoConfirmacion
      this.habitacion3.selected = this.habitacion1.selected
      this.habitacion3.typePreferentExtra = this.habitacion1.typePreferentExtra
      this.habitacion3.selectedExtra = this.habitacion1.selectedExtra
    },
    replicarInfo4() {
      this.habitacion4.search = this.habitacion1.search
      this.habitacion4.tituloDado = this.habitacion1.tituloDado
      this.habitacion4.nombres = this.simpleName.toUpperCase()
      this.habitacion4.apellidoP = this.fatherSurname.toUpperCase()
      this.habitacion4.apellidoM = this.motherSurname != null ? this.motherSurname.toUpperCase() : ""
      this.habitacion4.pickedPiso = this.habitacion1.pickedPiso
      this.habitacion4.pickedFumar = this.habitacion1.pickedFumar
      this.habitacion4.typePreferent = this.habitacion1.typePreferent
      this.habitacion4.mailContacto = this.habitacion1.mailContacto
      this.habitacion4.mailContactoConfirmacion = this.habitacion1.mailContactoConfirmacion
      this.habitacion4.selected = this.habitacion1.selected
      this.habitacion4.typePreferentExtra = this.habitacion1.typePreferentExtra
      this.habitacion4.selectedExtra = this.habitacion1.selectedExtra
    },
    replicarInfo5() {
      this.habitacion5.search = this.habitacion1.search
      this.habitacion5.tituloDado = this.habitacion1.tituloDado
      this.habitacion5.nombres = this.simpleName.toUpperCase()
      this.habitacion5.apellidoP = this.fatherSurname.toUpperCase()
      this.habitacion5.apellidoM = this.motherSurname != null ? this.motherSurname.toUpperCase() : ""
      this.habitacion5.pickedPiso = this.habitacion1.pickedPiso
      this.habitacion5.pickedFumar = this.habitacion1.pickedFumar
      this.habitacion5.typePreferent = this.habitacion1.typePreferent
      this.habitacion5.mailContacto = this.habitacion1.mailContacto
      this.habitacion5.mailContactoConfirmacion = this.habitacion1.mailContactoConfirmacion
      this.habitacion5.selected = this.habitacion1.selected
      this.habitacion5.typePreferentExtra = this.habitacion1.typePreferentExtra
      this.habitacion5.selectedExtra = this.habitacion1.selectedExtra
    },
    validateEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },
 //METODOS KB49419
    validationMemberFR(){
      this.isModalQuestionSocio = true;  
      //this.banderaValidacionStorage = true;
    },
    closeQuestionSocio() {
      this.$root.$emit('bv::toggle::collapse', 'datosContacto');
      this.isModalQuestionSocio = false;
      //clearInterval(this.myInterval);
    },
    openURLSocio(){
      //this.banderaValidacionStorage = true;
      this.isModalQuestionSocio = false;
      //START KB51882
      this.myInterval = setInterval(this.validacionesLocalStorage, 1000);
      //END KB51882
      this.isModalURLSocio = true;
     },
    closeURLSocio() {
      this.banderaFiesaRe = true;
      this.consultFiestaRewards();
      this.$root.$emit('bv::toggle::collapse', 'datosPersonales');
      this.isModalURLSocio = false;
    },
    closeURLSocio2() {
      //START KB51882
      clearInterval(this.myInterval);
      //END KB51882
      if(localStorage.getItem('Tier')){
        this.banderaFiesaRe = true;
        this.consultFiestaRewards();
       // this.$root.$emit('bv::toggle::collapse', 'datosPersonales');
        this.isModalURLSocio = false;
        this.isModalPass = true;

      }else{
        this.$root.$emit('bv::toggle::collapse', 'datosContacto');
        this.isModalURLSocio = false

      }

  },
  openisModalPass() {
    this.isModalPass = false;
    this.$root.$emit('bv::toggle::collapse', 'datosPersonales');
    },
  validacionesLocalStorage() {
    //this.banderaValidacionStorage == false;
    if(localStorage.getItem('Tier')){
      this.banderaValidacionStorage = true;
    }else{
      this.banderaValidacionStorage = false;
    }
  }
  },
  computed: {
    persistRegistryData() {
      return this.$store.getters.getPersistRegistryData
    },
    inputValidation(event, type, maxLength) {
      switch (type) {
        case 'numeric':
          var code = (event.which) ? event.which : event.keyCode;
          if ((code < 48 || code > 57 && code !== 46) || event.target.value.length == maxLength) {
            event.preventDefault()
          }
          return true;
          break;

        default:
          break;
      }
    },
    filteredListTitulos() {
      return this.habitacion1.titulos.filter(titulo => {
        return titulo.nombre.toLowerCase().includes(this.habitacion1.tituloDado.toLowerCase())
      })
    },
    filteredListPaises() {
      return this.habitacion1.paises.filter(pais => {
        this.selectedCountry = this.habitacion1.paisSeleccionado
        return pais.nombre.toLowerCase().includes(this.habitacion1.paisSeleccionado.toLowerCase())
      })
    },
    filteredListTelefono() {
      //console.log("filteredListTelefono" + JSON.stringify(this.jsonPaises));
      //console.log(this.codePaisNew);
      //this.codePaisNew= 'MARSHALL';
      return this.jsonPaises.filter(pais => {
      //this.selectedCountry = this.habitacion1.paisSeleccionado
        return pais.fullname.toLowerCase().includes(this.codePaisNew.toLowerCase())
    })

    },
    filteredListEstado() {
      return this.habitacion1.estados.filter(estado => {
        return estado.stateName.toLowerCase().includes(this.habitacion1.estadoSeleccionado.toLowerCase())
      })
    },
    filteredListHorasIn() {
      return this.habitacion1.horasIn.filter(horaIn => {
        return horaIn.nombre.toLowerCase().includes(this.habitacion1.horaInSeleccionado.toLowerCase())
      })
    },
    filteredListHorasOut() {
      return this.habitacion1.horasOut.filter(horaOut => {
        return horaOut.nombre.toLowerCase().includes(this.habitacion1.horaOutSeleccionado.toLowerCase())
      })
    },

    // Tipo de preferencia
    selectAll: {
      get: function () {
        return this.habitacion1.typeRoomsPreferents ? this.habitacion1.selected.length == this.habitacion1.typeRoomsPreferents.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.habitacion1.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
            selected.push(typeRoomPreferent.id);
          });
        }
        this.habitacion1.selected = selected;
      }
    },
    // Tipo de preferencia extra
    selectAllExtra: {
      get: function () {
        return this.habitacion1.typeExtrasPreferents ? this.habitacion1.selectedExtra.length == this.habitacion1.typeExtrasPreferents.length : false;
      },
      set: function (value) {
        var selectedExtra = [];
        if (value) {
          this.habitacion1.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
            selectedExtra.push(typeExtraPreferent.id);
          });
        }
        this.habitacion1.selectedExtra = selectedExtra;
      }
    },
    // Tipo de preferencia
    selectAllH2: {
      get: function () {
        return this.habitacion2.typeRoomsPreferents ? this.habitacion2.selected.length == this.habitacion2.typeRoomsPreferents.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.habitacion2.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
            selected.push(typeRoomPreferent.id);
          });
        }
        this.habitacion2.selected = selected;
      }
    },
    selectAllH3: {
      get: function () {
        return this.habitacion3.typeRoomsPreferents ? this.habitacion3.selected.length == this.habitacion3.typeRoomsPreferents.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.habitacion3.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
            selected.push(typeRoomPreferent.id);
          });
        }
        this.habitacion3.selected = selected;
      }
    },
    selectAllH4: {
      get: function () {
        return this.habitacion4.typeRoomsPreferents ? this.habitacion4.selected.length == this.habitacion4.typeRoomsPreferents.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.habitacion4.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
            selected.push(typeRoomPreferent.id);
          });
        }
        this.habitacion4.selected = selected;
      }
    },
    selectAllH5: {
      get: function () {
        return this.habitacion5.typeRoomsPreferents ? this.habitacion5.selected.length == this.habitacion5.typeRoomsPreferents.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.habitacion5.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
            selected.push(typeRoomPreferent.id);
          });
        }
        this.habitacion5.selected = selected;
      }
    },
    // Tipo de preferencia extra
    selectAllExtraH2: {
      get: function () {
        return this.habitacion2.typeExtrasPreferents ? this.habitacion2.selectedExtra.length == this.habitacion2.typeExtrasPreferents.length : false;
      },
      set: function (value) {
        var selectedExtra = [];
        if (value) {
          this.habitacion2.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
            selectedExtra.push(typeExtraPreferent.id);
          });
        }
        this.habitacion2.selectedExtra = selectedExtra;
      }
    },
    selectAllExtraH3: {
      get: function () {
        return this.habitacion3.typeExtrasPreferents ? this.habitacion3.selectedExtra.length == this.habitacion3.typeExtrasPreferents.length : false;
      },
      set: function (value) {
        var selectedExtra = [];
        if (value) {
          this.habitacion3.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
            selectedExtra.push(typeExtraPreferent.id);
          });
        }
        this.habitacion3.selectedExtra = selectedExtra;
      }
    },
    selectAllExtraH4: {
      get: function () {
        return this.habitacion4.typeExtrasPreferents ? this.habitacion4.selectedExtra.length == this.habitacion4.typeExtrasPreferents.length : false;
      },
      set: function (value) {
        var selectedExtra = [];
        if (value) {
          this.habitacion4.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
            selectedExtra.push(typeExtraPreferent.id);
          });
        }
        this.habitacion4.selectedExtra = selectedExtra;
      }
    },
    selectAllExtraH5: {
      get: function () {
        return this.habitacion5.typeExtrasPreferents ? this.habitacion5.selectedExtra.length == this.habitacion5.typeExtrasPreferents.length : false;
      },
      set: function (value) {
        var selectedExtra = [];
        if (value) {
          this.habitacion5.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
            selectedExtra.push(typeExtraPreferent.id);
          });
        }
        this.habitacion5.selectedExtra = selectedExtra;
      }
    },
    // Validador
    isDisabledEstado() {
      if (this.banSelectedPais) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledHuesped() {
      if (this.simpleName.length > 2 && this.fatherSurname.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledHuespedH2() {
      if (this.habitacion2.nombres.length > 2 && this.habitacion2.apellidoP.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledHuespedH3() {
      if (this.habitacion3.nombres.length > 2 && this.habitacion3.apellidoP.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledHuespedH4() {
      if (this.habitacion4.nombres.length > 2 && this.habitacion4.apellidoP.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledHuespedH5() {
      if (this.habitacion5.nombres.length > 2 && this.habitacion5.apellidoP.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContacto() {
      //console.log("@isDisabledContacto")
/*
      if(this.habitacion1.areaCode && !this.habitacion1.nationalNumber){
        this.habitacion1.nationalNumber = this.habitacion1.numTelefonico
      }
      let phoneLength = 10
      if(this.habitacion1.nationalNumber && this.habitacion1.nationalNumber.startsWith("1")){
        phoneLength = 11;
      }
      
      if ((this.pickedTelelefonoCelular != '') && this.habitacion1.numTelefonico
        && this.habitacion1.mailContacto.length > 3 && this.validateEmail(this.habitacion1.mailContacto)
        && this.banSelectedPais 
        && this.habitacion1.areaCode && this.habitacion1.nationalNumber && this.habitacion1.nationalNumber.length >= phoneLength
      ) {
        return false;
      } else {
        return true;
      }
      console.log("numero2" +this.numeroTelNew)
      console.log("codigo país" + this.codePaisNew)
*/
//console.log(this.numeroTelNew.length)
//NO ESPACIOS BLANCO

    var respuesta = "";
    if(this.numeroTelNew.length == 0){
      //console.log("son vacios numeroTelNew");
        this.respuesta = true;
    }else{
      //console.log("no lo son vacios numeroTelNew");
      this.respuesta =false;
    }

   if(this.codePaisNew.length == 0){
      //console.log("son vacios codePaisNew");
        this.respuesta = true;
    }else{
      //console.log("no lo son vacios codePaisNew");
      this.respuesta = false;
    }

     if(this.habitacion1.mailContacto.length == 0){
      //console.log("son vacios habitacion1.mailContacto");
        this.respuesta = true;
    }else{
      //console.log("no lo son vacios habitacion1.mailContacto");
      this.respuesta = false;
    }

    this.isDisabledContacto = respuesta;
    return respuesta
    },
    isDisabledContactoH2() {
      if (this.habitacion2.mailContacto.length > 3 && this.validateEmail(this.habitacion2.mailContacto)) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContactoV2() {
    if(this.numeroTelNew.length == 0 || this.codePaisNew.length == 0 || this.habitacion1.mailContacto == 0 || this.habitacion1.paisSeleccionado == 0  ){
          return true;
    }else{
        return false;
    }
    },
    isDisabledContactoH3() {
      if (this.habitacion3.mailContacto.length > 3 && this.validateEmail(this.habitacion3.mailContacto)) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContactoH4() {
      if (this.habitacion4.mailContacto.length > 3 && this.validateEmail(this.habitacion4.mailContacto)) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContactoH5() {
      if (this.habitacion5.mailContacto.length > 3 && this.validateEmail(this.habitacion5.mailContacto)) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario0() {
      if ((this.formulario1.huesped && this.formulario1.contacto
      )
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario() {
      if (this.formulario1.huesped && this.formulario1.contacto
        && this.formulario1.acompanante && this.formulario1.proforma
        && this.formulario1.requerimientos && this.formulario2.personales && this.formulario2.contacto
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario3() {
      if (this.formulario1.huesped && this.formulario1.contacto
        && this.formulario1.acompanante && this.formulario1.proforma
        && this.formulario1.requerimientos && this.formulario2.personales && this.formulario2.contacto
        && this.formulario3.personales && this.formulario3.contacto
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario4() {
      if (this.formulario1.huesped && this.formulario1.contacto
        && this.formulario1.acompanante && this.formulario1.proforma
        && this.formulario1.requerimientos && this.formulario2.personales && this.formulario2.contacto
        && this.formulario3.personales && this.formulario3.contacto
        && this.formulario4.personales && this.formulario4.contacto
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario5() {
      if (this.formulario1.huesped && this.formulario1.contacto
        && this.formulario1.acompanante && this.formulario1.proforma
        && this.formulario1.requerimientos && this.formulario2.personales && this.formulario2.contacto
        && this.formulario3.personales && this.formulario3.contacto
        && this.formulario4.personales && this.formulario4.contacto
        && this.formulario5.personales && this.formulario5.contacto
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  filters: {
    resalt: function (value, valueFromSearch) {
      if (!value) return ''
      valueFromSearch != '' ? value = value.replace(valueFromSearch, '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>') : value = value;
      return value;
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        // add Event Listeners
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
}



</script>


<style lang="scss" scoped>
@import '../../../assets/scss/config.scss';

.imagenSocio{
   max-width: 90%;
   align-content: center;
}

.inputUppercase {
  text-transform: uppercase;
}

.section-full {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #fff;
  top: 0;
  right: -100%;
  z-index: 10;
  transition: all .3s !important;
  overflow: hidden;
}

.section-full__header {
  background: white;
  padding: 17.5px 50px;
  position: relative;
  border-bottom: 1px solid #e7e8e9;

  button {
    width: 50px;
    height: 56px;
    background: transparent;
    color: #005a83;
    border: none;
    position: absolute;
    left: 0;
    top: 0;
    padding: 0;
    border-right: solid 1px rgba(255, 255, 255, 0.2);

    span {
      font-size: 24px;
    }

    &:focus {
      outline: none;
    }
  }

  h4 {
    margin: 0;
    font-size: 17px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.24;
    letter-spacing: 0.43px;
  }
}

.section-full__body {
  height: calc(100% - 165px);
  padding-bottom: 58px;
  overflow: auto;
}

.section-full__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 15px;
  width: 100%;

  button {
    &:first-child {
      margin-bottom: 15px;
    }
  }
}

.section-full--open {
  right: 0;
  transition: all .3s !important;
}

.form-element,
.resort {
  margin-top: 16px !important;
}

// .form-element:nth-child(1) {
//   margin-top: 0 !important;
// }
// .acompanante,
// .requerimiento {
//   .form-element:nth-child(3) {
//     margin-top: 0 !important;
//   }
// }
.resaltar {
  font-weight: 500;
}

.espacio {
  display: flex;
  position: relative;
  min-height: 70vh;
  width: 100%;
  margin-top: 57px;
  padding-top: 32px;
}

.pasos {
  color: $grayBrownish;
  font-size: $font-size-biglarge;
  font-weight: 300;
}

.PC-color--colorBase3 {
  color: #0c5458;
  font-size: $font-size-exlarge;
}

.ativePaso {
  color: #0c5458;
  font-size: $font-size-biglarge;
  font-weight: 500;
}

.replicar {
  color: #0c5458;
  font-weight: 500;
  cursor: pointer;
}

// Formulario
.botones {
  margin-bottom: 45px;
}

// Habitaciones
.habitaciones {
  margin-top: 40px;
  margin-bottom: 80px;

  i {
    font-size: 18px;
  }

  .navi {
    float: right;
  }

  .editarDatos {
    font-size: $font-size-base;
    color: #0c5458;
    float: right;
  }

  .habitacionTitle {
    font-size: $font-size-exlarge;
    font-weight: bold;
    padding: 16px;
    background: #efece7;
  }

  .campos {
    border-bottom: 1px solid $colorBase5;

    .datos {
      padding-bottom: 24px;
    }

    .tituloDatos {
      margin: 0;
      color: $grayBrownish;
      font-size: $font-size-large;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    .camposActive {
      color: #0c5458;
      font-weight: 500;
    }

    .tituloDatosEditar {
      margin: 0;
      color: #006900;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    .cardsInfo {
      background-color: #d1ecf1;

      .nota {
        font-size: $font-size-base;
        color: $grayShadeDark;
      }

      .notaAzul {
        font-size: $font-size-base;
        color: $colorBase2;
        font-weight: 500;
      }
    }
  }

  @media (max-width: 736px) {
    .buscadorCard {
      width: 185% !important;
      padding: 20px !important;
      border: 1px solid #e7e8e9 !important;
    }
  }

  .botonesInfo {
    left: 50%;
  }

  @media only screen and (max-width: 992px) {
    .botonesInfo {
      left: 0;
    }

    .espacio {
      margin-top: 200px;
    }
  }
}

.barTop {
  display: none;
}

.barRight {
  display: block;
}

@media only screen and (max-width: 992px) {
  .espacio {
    margin-top: 100px;
  }

  .barTop {
    display: block;
  }

  .barRight {
    display: none;
  }
}

@media only screen and (max-width: 410px) {
  .espacio {
    margin-top: 130px;
  }
}

//START KB49419
.wrapper {
  z-index: 1000 !important;
  display: grid;
  grid-template-columns: 30% 65%;
}
//END KB49419
</style>
